/**
 * KKM Sipariş Wizard v10
 * Tüm veri admin.kahvekavurmamerkezi.com'dan gelir.
 */

function kwConfetti(el) {
  if(!el) return;
  const rect = el.getBoundingClientRect();
  const canvas = document.createElement('canvas');
  canvas.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:99997;';
  canvas.width = window.innerWidth; canvas.height = window.innerHeight;
  document.body.appendChild(canvas);
  const ctx = canvas.getContext('2d');
  const cx = rect.left + rect.width/2, cy = rect.top;
  const colors = ['#9A8968','#5C5040','#D4C4A8','#7D6E52','#3A3028'];
  const particles = Array.from({length:38}, () => ({
    x:cx, y:cy, vx:(Math.random()-0.5)*9, vy:-(Math.random()*8+3),
    r:Math.random()*4+2, color:colors[Math.floor(Math.random()*colors.length)],
    alpha:1, gravity:0.35
  }));
  let frame;
  (function animate() {
    ctx.clearRect(0,0,canvas.width,canvas.height);
    let alive=false;
    particles.forEach(p=>{
      p.x+=p.vx; p.y+=p.vy; p.vy+=p.gravity; p.alpha-=0.022;
      if(p.alpha>0){ alive=true; ctx.globalAlpha=p.alpha; ctx.fillStyle=p.color; ctx.beginPath(); ctx.arc(p.x,p.y,p.r,0,Math.PI*2); ctx.fill(); }
    });
    ctx.globalAlpha=1;
    if(alive) frame=requestAnimationFrame(animate); else canvas.remove();
  })();
  setTimeout(()=>{ cancelAnimationFrame(frame); canvas.remove(); }, 1800);
}
'use strict';

const KW_ADMIN = 'https://admin.kahvekavurmamerkezi.com';
const KW_MIN = 10, KW_MAX = 100, KW_STEP = 5;
const KW_PKG = {
  250:  { label:'250 gr',  short:'250gr' },
  1000: { label:'1 kg',    short:'1kg'   },
  2500: { label:'2,5 kg',  short:'2.5kg' },
  5000: { label:'5 kg',    short:'5kg'   },
};
const KW_LOGO_VID = '51978292724008';

function kwToast(msg, type, dur) {
  type = type||'info'; dur = dur||3500;
  let w = document.getElementById('kw-tw');
  if (!w) { w=document.createElement('div'); w.id='kw-tw'; w.style.cssText='position:fixed;top:20px;right:20px;z-index:99999;display:flex;flex-direction:column;gap:8px;pointer-events:none;'; document.body.appendChild(w); }
  const c={'info':'#7F5539','success':'#27ae60','error':'#c0392b','warning':'#c0392b'}[type];
  const i={'info':'ℹ','success':'✓','error':'✕','warning':'⚠'}[type];
  const t=document.createElement('div');
  t.style.cssText=`background:${c};color:#fff;padding:12px 18px;border-radius:10px;font-family:inherit;font-size:13px;font-weight:500;max-width:320px;box-shadow:0 4px 20px rgba(0,0,0,.18);display:flex;align-items:center;gap:9px;pointer-events:auto;`;
  t.innerHTML=`<span>${i}</span><span>${msg}</span>`;
  w.appendChild(t);
  setTimeout(()=>t.remove(), dur);
}

function kwConfirm(msg) {
  return new Promise(res => {
    let w=document.getElementById('kw-cw'); if(w)w.remove();
    w=document.createElement('div'); w.id='kw-cw';
    w.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:99998;display:flex;align-items:center;justify-content:center;';
    w.innerHTML=`<div style="background:#fff;border-radius:14px;padding:28px 24px;max-width:380px;width:90%;font-family:inherit;box-shadow:0 8px 40px rgba(0,0,0,.18);">
      <p style="font-size:14px;color:#3d2c1e;margin:0 0 20px;line-height:1.6;">${msg}</p>
      <div style="display:flex;gap:10px;justify-content:flex-end;">
        <button id="kw-cn" style="padding:9px 18px;border-radius:8px;border:1px solid #E6CCB2;background:#f9f5f0;font-family:inherit;font-size:13px;cursor:pointer;">İptal</button>
        <button id="kw-cy" style="padding:9px 18px;border-radius:8px;border:none;background:#7F5539;color:#fff;font-family:inherit;font-size:13px;cursor:pointer;">Tamam</button>
      </div></div>`;
    document.body.appendChild(w);
    w.querySelector('#kw-cy').addEventListener('click',()=>{w.remove();res(true);});
    w.querySelector('#kw-cn').addEventListener('click',()=>{w.remove();res(false);});
  });
}

class KahveWizard {
  constructor(cfg) {
    this.cfg = cfg;
    this._s = { step:0, type:null, character:null, beans:[], roast:null, grind:null, quantityKg:10, pkgDesigns:{}, packages:[], designType:null };
    this.data = { beans:{}, presets:[], packages:{} };
    this.catalog = { cekirdekler:[], ambalajlar:[] };
    this.presets = [];
    this._busy = false;
    this._init();
  }

  async _init() {
    document.addEventListener('click', e => this._click(e));
    document.addEventListener('keydown', e => { if(e.key==='Escape'&&this._s.step) this._confirmClose(); });
    window.addEventListener('popstate', () => { if(this._s.step>1){this.back();history.pushState(null,'','');} });
    await this._loadAll();
    if(this.cfg.customerId) this._loadSaved();
  }

  async _loadAll() {
    const showErr = msg => {
      const ov = document.getElementById('kw-overlay');
      if(ov) { ov.style.display='block'; ov.innerHTML=`<div style="min-height:100vh;display:flex;align-items:center;justify-content:center;background:rgba(28,24,18,.85);"><div style="background:#fff;padding:36px 40px;max-width:420px;text-align:center;font-family:inherit;"><div style="font-size:28px;margin-bottom:16px;">⚠️</div><h3 style="font-size:16px;font-weight:700;margin-bottom:8px;">Sistem Hatası</h3><p style="font-size:13px;color:#7D6E52;line-height:1.6;margin-bottom:20px;">${msg}</p><button onclick="location.reload()" style="background:#5C5040;color:#fff;border:none;padding:10px 24px;font-family:inherit;font-size:13px;cursor:pointer;">Tekrar Dene</button></div></div>`; }
    };
    try {
      const [br, pr, pkr] = await Promise.all([
        fetch(KW_ADMIN+'/?beans',    {cache:'no-store'}),
        fetch(KW_ADMIN+'/?api',      {cache:'no-store'}),
        fetch(KW_ADMIN+'/?packages', {cache:'no-store'}),
      ]);
      if(!br.ok)  { showErr('Çekirdek verisi alınamadı.'); return; }
      if(!pr.ok)  { showErr('Tarif verisi alınamadı.'); return; }
      if(!pkr.ok) { showErr('Ambalaj verisi alınamadı.'); return; }
      const bData  = await br.json();
      const pData  = await pr.json();
      const pkData = await pkr.json();
      if(!bData||!Object.keys(bData).length) { showErr('Çekirdek verisi boş.'); return; }
      if(!pkData||!Object.keys(pkData).length) { showErr('Ambalaj verisi boş. Admin\'den senkronize edin.'); return; }
      this.data.beans    = bData;
      this.data.presets  = pData;
      this.data.packages = pkData;
      this.catalog.cekirdekler = Object.entries(bData).map(([id,b]) => ({
        id:String(id), variantId:String(b.variantId||''), title:b.title||'',
        color:b.renk||'#7D4A2A', tatNotlari:b.tat||'', mensei:b.mensei||'',
        rakim:b.rakim||'', proses:b.proses||'',
        kavurmaTipi:Array.isArray(b.kavurmaTipi)?b.kavurmaTipi:['filtre','turk','espresso'],
        stockGr:(parseFloat(b.stock)>=0?parseFloat(b.stock):9999)*1000,
        price:parseFloat(b.price)||0, bayrak:b.bayrak||'', foto:b.foto||'', tur:b.tur||'',
      })).filter(b=>b.stockGr>0);
      this.presets = (Array.isArray(pData)?pData:[]).map(p=>({
        id:p.id, title:p.title, type:p.type,
        character:p.karakter||p.character,
        suggestedRoast:p.suggested_roast||p.suggestedRoast,
        beans:(p.beans||[]).map(b=>({id:String(b.id||b.bean_id),ratio:parseInt(b.ratio)||0})),
      }));
      // ── PATCH 1: price eklendi ──
      this.catalog.ambalajlar = Object.entries(pkData)
        .filter(([,p])=>p.productId&&(p.stock??9999)>0)
        .map(([ambId,p])=>({
          ambId,
          variantId:    String(p.variantId||''),
          productId:    String(p.productId),
          isim:         p.isim||'',
          tur:          p.tur||'',
          renk:         p.renk||'',
          ebat:         p.ebat||'',
          ebat_gr:      p.ebat_gr||0,
          stock:        p.stock??9999,
          imgs:         p.imgs||[],
          price:        parseFloat(p.price)||0,
        }));
      window.KW_AMBALAJ_DATA = pkData;
    } catch(e) { showErr('Sunucuya bağlanılamadı: '+e.message); return; }
    const urlBlend = new URLSearchParams(window.location.search).get('blend');
    if(urlBlend) { this._loadBlendById(urlBlend); }
    else { const saved=this._doRestore(); if(saved)this._goStep(this._s.step); else this._goStep(1); }
  }

  _save() {
    try {
      localStorage.setItem('kw_s', JSON.stringify({
        step:this._s.step, type:this._s.type, character:this._s.character,
        roast:this._s.roast, grind:this._s.grind, quantityKg:this._s.quantityKg,
        packages:this._s.packages, pkgDesigns:this._s.pkgDesigns, designType:this._s.designType,
        beans:this._s.beans.map(b=>({id:b.id,ratio:b.ratio})),
      }));
    } catch(e){}
  }

  _reset(toStep1=true) {
    localStorage.removeItem('kw_s');
    Object.assign(this._s,{step:0,type:null,character:null,beans:[],roast:null,grind:null,quantityKg:10,pkgDesigns:{},packages:[],designType:null,maxStep:0,logoUrl:null,logoFile:null});
    document.querySelectorAll('.kw-option-card.selected,.kw-bean-card.selected,.kw-roast-suggested').forEach(el=>el.classList.remove('selected','kw-roast-suggested'));
    const prev=document.getElementById('kw-logo-preview'); if(prev){prev.style.display='none';prev.innerHTML='';}
    const area=document.querySelector('.kw-upload-area'); if(area){area.style.display='';delete area.dataset.kkmInit;}
    const inp=document.getElementById('kw-logo-file'); if(inp){inp.value='';delete inp.dataset.kkmInit;}
    const pkgRows=document.getElementById('kw-pkg-rows'); if(pkgRows){pkgRows.innerHTML='';pkgRows.dataset.built='0';}
    const ambStep=document.getElementById('kw-ambalaj-step'); if(ambStep) ambStep.innerHTML='';
    if(toStep1) this._goStep(1);
  }

  _doRestore() {
    try {
      const raw=localStorage.getItem('kw_s'); if(!raw) return false;
      const sv=JSON.parse(raw); if(!sv||!sv.step||sv.step<2) return false;
      sv.beans=(sv.beans||[]).map(b=>{const f=this.catalog.cekirdekler.find(c=>c.id===b.id);return f?{...f,ratio:b.ratio}:null;}).filter(Boolean);
      Object.assign(this._s,sv); return true;
    } catch(e) { return false; }
  }

  async _confirmClose() {
    if(this._s.step>1){this.back();return;}
    if(await kwConfirm('Sipariş oluşturmayı iptal etmek istiyor musunuz?')) this.close();
  }

  start() {
    this._reset(false);
    document.getElementById('kw-overlay').style.display='block';
    document.getElementById('kw-close').style.display='flex';
    history.pushState(null,'','');
    this._goStep(1);
  }

  close() {
    document.getElementById('kw-overlay').style.display='none';
    document.getElementById('kw-close').style.display='none';
  }

  next() { if(this._valid()) this._goStep(this._s.step+1); }
  back() { this._s.step<=1?this._confirmClose():this._goStep(this._s.step-1); }

  _goStep(n) {
    if(n>this.cfg.totalSteps) return;
    if(n>(this._s.maxStep||0)) this._s.maxStep=n;
    document.querySelectorAll('.kw-step').forEach(el=>{el.style.display=el.dataset.stepPanel==n?'block':'none';});
    const pct=((n-1)/this.cfg.totalSteps*100);
    const pf=document.getElementById('kw-progress-fill'); if(pf) pf.style.width=pct+'%';
    document.querySelectorAll('.kw-step-nav__item').forEach(el=>{
      const s=parseInt(el.dataset.step),reached=s<=(this._s.maxStep||n);
      el.classList.toggle('active',s===n); el.classList.toggle('done',s<n);
      el.style.opacity=reached?'1':'0.35'; el.style.cursor=reached?'pointer':'default';
    });
    this._s.step=n; this._save();
    if(n===2) this._renderStep2();
    if(n===3) this._renderBeans();
    if(n===4) { this._renderRoast(); setTimeout(()=>this._renderStockPanel(),100); }
    if(n===5) this._renderKg();
    if(n===6) this._renderPkgStep();
    if(n===7) this._renderAmbalajStep();
    if(n===8) this._renderPreview();
    this._navBtns(); this._summary();
    setTimeout(()=>this._autoSelectAndAdvance(n), 80);
    window.scrollTo({top:0,behavior:'smooth'});
  }

  _valid() {
    const s=this._s;
    switch(s.step){
      case 1: return !!s.type;
      case 2: return !!s.character;
      case 3: return this._beansOk();
      case 4: return !!s.roast&&!!s.grind;
      case 5: return s.quantityKg>=KW_MIN&&s.quantityKg<=KW_MAX;
      case 6: return this._pkgsOk();
      case 7: return this._pkgDesignsOk()&&(this._s.designType!=='custom'||!!this._s.logoUrl);
      case 8: return !!s.designType;
      default: return true;
    }
  }

  _beansOk() {
    const s=this._s; if(!s.character) return false;
    if(s.character==='single') return s.beans.length===1;
    return s.beans.length>=2&&s.beans.length<=3&&s.beans.reduce((a,b)=>a+b.ratio,0)===100;
  }
  _pkgDesignsOk() {
    const s=this._s;
    const active=(s.packages||[]).filter(p=>p.count>0).map(p=>p.sizeGr);
    return active.length>0&&active.every(sz=>!!s.pkgDesigns[sz])&&!!s.designType;
  }

  _initLogoUpload() {
    const input=document.getElementById('kw-logo-file'); if(!input||input.dataset.kkmInit) return;
    input.dataset.kkmInit='1';
    input.addEventListener('change', e=>{
      const file=e.target.files?.[0]; if(!file) return;
      const allowedExts=['.pdf','.svg','.ai','.eps'];const fileExt=file.name.toLowerCase().slice(file.name.lastIndexOf('.'));const isPdf=file.type==='application/pdf';const isSvg=file.type==='image/svg+xml';if(!isPdf&&!isSvg&&!allowedExts.includes(fileExt)){kwToast('PDF, SVG, AI veya EPS formatında yükleyin.','warning');input.value='';return;}
      if(file.size>10*1024*1024) { kwToast('Dosya 10MB den kucuk olmali.','warning'); input.value=''; return; }
      const reader=new FileReader();
      reader.onload=ev=>{
        this._s.logoUrl=ev.target.result; this._s.logoFile=file.name;
        this._renderLogoPreview(ev.target.result,file.name);
        this._summary(); this._navBtns(); this._save(); input.value='';
      };
      reader.readAsDataURL(file);
    });
    const area=document.querySelector('.kw-upload-area');
    if(area){
      area.addEventListener('dragover',e=>{e.preventDefault();area.classList.add('kw-dz--over');});
      area.addEventListener('dragleave',()=>area.classList.remove('kw-dz--over'));
      area.addEventListener('drop',e=>{
        e.preventDefault();area.classList.remove('kw-dz--over');
        const file=e.dataTransfer.files?.[0]; if(!file) return;
        const dt=new DataTransfer(); dt.items.add(file); input.files=dt.files;
        input.dispatchEvent(new Event('change'));
      });
    }
  }

  _renderLogoPreview(dataUrl, name) {
    const area=document.querySelector('.kw-upload-area'); if(area) area.style.display='none';
    const prev=document.getElementById('kw-logo-preview'); if(!prev) return;
    prev.style.display='block';
    prev.innerHTML=`<div style="display:flex;align-items:center;gap:14px;padding:12px;border:1px solid #e0e0e0;border-radius:8px;background:#fafafa;">
      <img src="${dataUrl}" style="width:80px;height:80px;object-fit:contain;border:1px solid #eee;border-radius:4px;background:#fff;padding:4px;">
      <div style="flex:1;min-width:0;">
        <div style="font-size:12px;font-weight:600;color:#1C1812;margin-bottom:3px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">${name}</div>
        <div style="font-size:11px;color:#27ae60;margin-bottom:8px;font-weight:600;">✓ Logo yüklendi</div>
        <button type="button" onclick="window.kahveWizard._removeLogo()" style="background:none;border:none;color:#c0392b;font-size:11px;cursor:pointer;padding:0;text-decoration:underline;font-family:inherit;">Kaldır ve tekrar yükle</button>
      </div></div>`;
  }

  _removeLogo() {
    this._s.logoUrl=null; this._s.logoFile=null;
    const input=document.getElementById('kw-logo-file'); if(input){input.value='';delete input.dataset.kkmInit;}
    const prev=document.getElementById('kw-logo-preview'); if(prev){prev.style.display='none';prev.innerHTML='';}
    const area=document.querySelector('.kw-upload-area'); if(area) area.style.display='';
    this._initLogoUpload(); this._summary(); this._navBtns(); this._save();
  }

  _pkgsOk() {
    const s=this._s; if(!s.packages?.length) return false;
    return Math.abs(s.packages.reduce((a,p)=>a+p.sizeGr*p.count,0)-s.quantityKg*1000)<1;
  }

  _click(e) {
    const t=e.target;
    const card=t.closest('[data-group]'); if(card){this._cardClick(card);return;}
    if(t.closest('#kw-btn-back'))        {this.back();return;}
    if(t.closest('#kw-btn-cart'))        {this.addToCart(false);return;}
    if(t.closest('#kw-btn-cart2'))       {this.addToCart(false);return;}
    if(t.closest('#kw-btn-buynow'))      {this.addToCart(true);return;}
    if(t.closest('#kw-btn-buynow2'))     {this.addToCart(true);return;}
    if(t.closest('#kw-close'))           {this._confirmClose();return;}
    if(t.closest('.kw-btn--hero-start')) {this.start();return;}
    const nav=t.closest('.kw-step-nav__item');
    if(nav){const ts=parseInt(nav.dataset.step);if(!isNaN(ts)&&ts<=(this._s.maxStep||this._s.step)){this._goStep(ts);return;}}
    if(t.closest('.kw-ratio-btn')){const b=t.closest('.kw-ratio-btn');this._ratio(parseInt(b.dataset.idx),parseInt(b.dataset.delta));return;}
    if(t.closest('.kw-pkg-add')){this._pkgAdd(parseInt(t.closest('.kw-pkg-add').dataset.size));return;}
    if(t.closest('.kw-pkg-rem')){this._pkgRem(parseInt(t.closest('.kw-pkg-rem').dataset.size));return;}
    if(t.closest('.kw-qty-preset')){const btn=t.closest('.kw-qty-preset'),v=parseInt(btn.dataset.v);if(btn.classList.contains('kw-qty-preset--more')){const sm=this._maxKgByStock();this._showContact(sm<KW_MAX?'yetersiz_stok':'yuksek_hacim');return;}this._setQty(v);return;}
    if(t.closest('.kw-qty-btn')){this._changeQty(t.closest('.kw-qty-btn').dataset.dir==='up'?1:-1);return;}
    if(t.closest('#kw-btn-reset')){this._confirmReset();return;}
    if(t.closest('#kw-save-blend')){this.saveBlend();return;}
    if(t.closest('#kw-contact-submit')){this._submitContact();return;}
    if(t.closest('#kw-contact-cancel')||t.closest('#kw-contact-cancel2')){document.getElementById('kw-contact-modal').classList.remove('open');return;}
    if(t.closest('.kw-saved-load')){this._loadBlend(t.closest('.kw-saved-load').dataset.id);return;}
    if(t.closest('.kw-saved-del')){this._deleteBlend(t.closest('.kw-saved-del').dataset.id);return;}
  }

  _cardClick(card) {
    const group=card.dataset.group; if(!group) return;
    if(group==='bean'){this._toggleBean(card.dataset.value);return;}
    if(group==='preset'){this._applyPreset(card.dataset.value);return;}
    document.querySelectorAll(`[data-group="${group}"]`).forEach(c=>c.classList.remove('selected'));
    card.classList.add('selected');
    const v=card.dataset.value;
    const _go=()=>{ this._summary();this._navBtns();this._save();setTimeout(()=>this.next(),300); };
    switch(group){
      case 'step1-type': this._s.type=v;this._s.beans=[];_go();break;
      case 'step2-character': this._s.character=v;this._s.beans=[];_go();break;
      case 'step4-roast':
        this._s.roast=v;this._renderRoast();this._summary();this._navBtns();this._save();
        if(this._s.type==='espresso'){this._s.grind='cekirdek';setTimeout(()=>this.next(),300);}
        else if(this._s.grind){setTimeout(()=>this.next(),300);}
        else{setTimeout(()=>{const gs=document.getElementById('kw-grind-'+(this._s.type||'filtre'));if(gs)gs.scrollIntoView({behavior:'smooth',block:'center'});},150);}
        break;
      case 'step4-grind':
        this._s.grind=v;this._summary();this._navBtns();this._save();
        if(this._s.roast) setTimeout(()=>this.next(),300);
        break;
      case 'step7-logo-design':
        this._s.designType=v;
        const lu=document.getElementById('kw-logo-upload-7');
        if(lu){lu.style.display=v==='custom'?'block':'none';if(v==='custom'){this._initLogoUpload();if(this._s.logoUrl)this._renderLogoPreview(this._s.logoUrl,this._s.logoFile||'logo');}}
        this._summary();this._navBtns();this._save();
        if(v!=='custom') setTimeout(()=>this.next(),300);
        break;
      case 'step8-design':
        this._s.designType=v;
        const lu2=document.getElementById('kw-logo-upload-7');
        if(lu2){lu2.style.display=v==='custom'?'block':'none';if(v==='custom'){this._initLogoUpload();if(this._s.logoUrl)this._renderLogoPreview(this._s.logoUrl,this._s.logoFile||'logo');}}
        this._renderOrderPreview();this._summary();this._navBtns();this._save();
        if(v!=='custom') setTimeout(()=>this.next(),300);
        break;
    }
  }

  _renderStep2() {
    this._renderPresetsGrid();
    if(this._s.character) document.querySelector(`[data-group="step2-character"][data-value="${this._s.character}"]`)?.classList.add('selected');
  }
  _renderPresetsGrid() {
    const g=document.getElementById('kw-presets-grid'); if(!g) return;
    const tNow=this._s.type;
    const tL={filtre:'Filtre Kahve',turk:'Türk Kahvesi',espresso:'Espresso'};
    const avail=this.presets.filter(p=>this._presetInStock(p));
    if(!avail.length){g.innerHTML='<p class="kw-empty" style="grid-column:1/-1">Şu an stokta hazır tarif bulunmuyor.</p>';return;}
    let html='';
    if(tNow){
      const ft=avail.filter(p=>p.type===tNow);
      html=ft.length?ft.map(p=>this._presetHTML(p)).join(''):`<p class="kw-empty" style="grid-column:1/-1">${tL[tNow]} için tarif bulunamadı.</p>`;
    } else {
      ['turk','filtre','espresso'].forEach(type=>{
        const gr=avail.filter(p=>p.type===type); if(!gr.length)return;
        html+=`<div class="kw-preset-group"><div class="kw-preset-group__label">${tL[type]}</div><div class="kw-preset-group__cards">${gr.map(p=>this._presetHTML(p)).join('')}</div></div>`;
      });
    }
    g.innerHTML=html;
  }
  _presetHTML(p) {
    const rL={light:'Light',medium:'Medium',dark:'Medium Dark'}[p.suggestedRoast]||'';
    const cL=p.character==='single'?'Single Origin':'Blend';
    const rows=p.beans.map(b=>{
      const cat=this.catalog.cekirdekler.find(x=>x.id===b.id);
      const col=cat?.color||'#B08968',tit=cat?.title||b.id;
      const pct=p.character==='single'?'%100':'%'+b.ratio;
      return `<div style="display:flex;align-items:center;justify-content:space-between;gap:8px;padding:5px 0;border-bottom:1px solid rgba(0,0,0,.06);"><span style="display:flex;align-items:center;gap:7px;min-width:0;"><span style="width:8px;height:8px;border-radius:50%;background:${col};display:inline-block;flex-shrink:0;"></span><span style="font-size:12px;color:#5C5040;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${tit}</span></span><span style="font-weight:700;color:#5C5040;flex-shrink:0;">${pct}</span></div>`;
    }).join('');
    const fmt=v=>new Intl.NumberFormat('tr-TR',{style:'currency',currency:'TRY',maximumFractionDigits:0}).format(v);
    let pricePerKg=0;
    if(p.character==='single'){const cat=this.catalog.cekirdekler.find(x=>x.id===p.beans[0]?.id);pricePerKg=cat?.price||0;}
    else{p.beans.forEach(b=>{const cat=this.catalog.cekirdekler.find(x=>x.id===b.id);if(cat?.price)pricePerKg+=cat.price*(b.ratio/100);});}
    const priceTag=pricePerKg>0?`<span style="font-size:11px;font-weight:700;color:#5C5040;background:#f4f0ea;padding:3px 9px;border-radius:20px;">${fmt(pricePerKg)}<small style="font-weight:400;font-size:10px;">/kg</small></span>`:'';
    return `<div class="kw-preset-card" data-group="preset" data-value="${p.id}"><div style="display:flex;align-items:flex-start;justify-content:space-between;gap:8px;margin-bottom:6px;"><div class="kw-preset-card__badges" style="margin-bottom:0;"><span class="kw-preset-badge kw-preset-badge--char">${cL}</span>${rL?`<span class="kw-preset-badge kw-preset-badge--roast">Önerilen: ${rL}</span>`:''}</div>${priceTag}</div><strong>${p.title}</strong><div style="margin-top:10px;">${rows}</div></div>`;
  }
  _presetInStock(p) { return p.beans.every(pb=>{const c=this.catalog.cekirdekler.find(x=>x.id===pb.id);return c&&c.stockGr>0;}); }
  _applyPreset(id) {
    const p=this.presets.find(x=>x.id===id); if(!p) return;
    if(!this._presetInStock(p)){kwToast('Bu tarife ait çekirdeklerin stoğu yeterli değil.','error');return;}
    this._s.type=p.type;this._s.character=p.character;this._s.roast=null;
    this._s.beans=p.beans.map(pb=>{const f=this.catalog.cekirdekler.find(c=>c.id===pb.id);return f?{...f,ratio:pb.ratio}:null;}).filter(Boolean);
    document.querySelectorAll('[data-group="step2-character"]').forEach(c=>{c.classList.toggle('selected',c.dataset.value===p.character);});
    this._suggestedRoast=p.suggestedRoast||null;
    this._goStep(4);
    if(p.suggestedRoast){setTimeout(()=>{document.querySelectorAll('[data-group="step4-roast"]').forEach(card=>{card.classList.toggle('kw-roast-suggested',card.dataset.value===p.suggestedRoast);});},100);}
  }

  _renderBeans() {
    const char=this._s.character;
    const d=document.getElementById('kw-bean-desc'); if(d) d.textContent=char==='single'?'Bir çekirdek seçin.':'En az 2, en fazla 3 çekirdek seçin.';
    const avail=this.catalog.cekirdekler.filter(c=>c.stockGr>0);
    const CO={'Brasil':0,'Santos':0,'Cerrado':0,'Ethiopia':1,'Etiyopya':1,'Colombia':2,'Kenya':3,'Rwanda':4,'El Salvador':5,'Honduras':6,'Uganda':7,'Peru':8};
    const sorted=[...avail].sort((a,b)=>{const ga=Object.entries(CO).find(([k])=>a.title.includes(k));const gb=Object.entries(CO).find(([k])=>b.title.includes(k));return (ga?ga[1]:99)-(gb?gb[1]:99);});
    const g=document.getElementById('kw-beans-grid'); if(!g) return;
    g.innerHTML=sorted.map(c=>{
      const pL=c.price>0?`<span style="position:absolute;bottom:8px;left:8px;background:rgba(255,255,255,.92);font-size:11px;font-weight:700;padding:3px 9px;">${new Intl.NumberFormat('tr-TR',{style:'currency',currency:'TRY',maximumFractionDigits:0}).format(c.price)}<small>/kg</small></span>`:'';
      const stockBadge=c.stockGr<=0?`<span style="position:absolute;top:6px;right:6px;background:#c0392b;color:#fff;font-size:9px;padding:2px 6px;font-weight:700;letter-spacing:.04em;">STOK YOK</span>`:'';
      const vis=c.foto?`<img src="${c.foto}" alt="${c.title}" style="width:100%;height:100%;object-fit:cover;">`:c.bayrak?`<img src="https://flagcdn.com/w320/${c.bayrak}.png" alt="" style="width:100%;height:100%;object-fit:cover;filter:sepia(30%) saturate(80%);">`:`<div style="width:100%;height:100%;background:${c.color};"></div>`;
      const cardStyle=c.stockGr<=0?'opacity:.5;pointer-events:none;':'';
      return `<div class="kw-bean-card" data-group="bean" data-value="${c.id}" style="${cardStyle}">
        <div class="kw-bean-card__visual" style="position:relative;overflow:hidden;background:#fff;">${vis}${pL}${stockBadge}</div>
        <div class="kw-bean-card__body"><strong>${c.title}</strong><span class="kw-bean-origin">${c.mensei}</span><span class="kw-bean-notes">${c.tatNotlari}</span><div class="kw-bean-tags"><span class="kw-tag">${c.rakim}</span><span class="kw-tag">${c.proses}</span>${c.tur?`<span class="kw-tag kw-tag--tur" style="background:#3A3028;color:#fff;">${c.tur}</span>`:''}</div></div>
      </div>`;
    }).join('')||'<p class="kw-empty">Çekirdek bulunamadı.</p>';
    this._s.beans.forEach(b=>document.querySelector(`[data-group="bean"][data-value="${b.id}"]`)?.classList.add('selected'));
    const rd=document.getElementById('kw-blend-ratios');
    if(char!=='single'){rd.style.display='block';if(this._s.beans.length>=2)this._renderRatioCards();else if(this._s.beans.length===1)this._renderRatioSingle();else this._renderRatioEmpty();}
    else rd.style.display='none';
    this._beanWarn();
  }
  _beanWarn() {
    const char=this._s.character,n=this._s.beans.length;let msg='';
    if(char==='blend'){if(n===0)msg='En az 2 çekirdek seçin.';else if(n===1)msg='Bir çekirdek daha seçin.';else{const t=this._s.beans.reduce((a,b)=>a+b.ratio,0);if(t!==100)msg=`Oranlar toplamı %${t} — %100 olmalı.`;}}
    const w=document.getElementById('kw-bean-warning'); if(w){w.textContent=msg;w.style.display=msg?'block':'none';}
  }
  _toggleBean(id) {
    const char=this._s.character,MAX=char==='single'?1:3;
    const idx=this._s.beans.findIndex(b=>b.id===id);
    if(idx!==-1){this._s.beans.splice(idx,1);document.querySelector(`[data-group="bean"][data-value="${id}"]`)?.classList.remove('selected');}
    else{
      if(this._s.beans.length>=MAX){if(char==='single'){const r=this._s.beans.shift();document.querySelector(`[data-group="bean"][data-value="${r.id}"]`)?.classList.remove('selected');}else return;}
      const c=this.catalog.cekirdekler.find(x=>x.id===id); if(!c)return;
      this._s.beans.push({...c,ratio:0});
      document.querySelector(`[data-group="bean"][data-value="${id}"]`)?.classList.add('selected');
    }
    if(char!=='single'){
      if(this._s.beans.length===1){this._s.beans[0].ratio=50;this._renderRatioSingle();}
      else if(this._s.beans.length>=2){this._distRatios();this._renderRatioCards();}
      else this._renderRatioEmpty();
    }
    if(char==='single'&&this._s.beans.length===1){this._beanWarn();this._navBtns();this._summary();this._save();setTimeout(()=>{if(this._valid())this.next();},280);return;}
    this._beanWarn();this._navBtns();this._summary();this._save();
  }
  _distRatios(){const n=this._s.beans.length;if(!n)return;const base=Math.floor(100/n/10)*10;let sum=0;this._s.beans.forEach(b=>{b.ratio=base;sum+=base;});this._s.beans[0].ratio+=(100-sum);}
  _renderRatioSingle(){
    const b=this._s.beans[0];
    document.getElementById('kw-blend-count').textContent='1';
    const bar=document.getElementById('kw-ratio-bar');
    if(bar)bar.innerHTML=`<div style="width:50%;height:100%;background:${b.color};border-radius:8px 0 0 8px;display:flex;align-items:center;justify-content:center;"><span style="font-size:13px;color:#fff;font-weight:600;">%50</span></div><div style="width:50%;height:100%;background:#e74c3c;opacity:.4;border-radius:0 8px 8px 0;display:flex;align-items:center;justify-content:center;"><span style="font-size:11px;color:#c0392b;">+2. çekirdek</span></div>`;
    const cards=document.getElementById('kw-ratio-cards');
    if(cards)cards.innerHTML=`<div class="kw-ratio-card" style="border-left:4px solid ${b.color};"><div class="kw-ratio-card__head"><span class="kw-rc-dot" style="background:${b.color};"></span><div><strong>${b.title}</strong><small>${b.mensei}</small></div></div><div class="kw-ratio-card__ctrl"><span style="font-size:18px;font-weight:700;color:${b.color};padding:0 12px;">%50</span></div></div>`;
    this._updateTotalBadge(50);
  }
  _renderRatioEmpty(){
    document.getElementById('kw-blend-count').textContent='0';
    const bar=document.getElementById('kw-ratio-bar');if(bar)bar.innerHTML='<div style="width:100%;height:100%;background:#e74c3c;opacity:.35;border-radius:8px;display:flex;align-items:center;justify-content:center;"><span style="font-size:12px;color:#c0392b;font-weight:600;">Çekirdek seçilmedi</span></div>';
    const cards=document.getElementById('kw-ratio-cards');if(cards)cards.innerHTML='<p style="font-size:12px;color:#c0392b;margin:0;">Aşağıdan en az 2 çekirdek seçin.</p>';
    this._updateTotalBadge(0);
  }
  _renderRatioCards(){
    const beans=this._s.beans; if(beans.length<2)return;
    document.getElementById('kw-blend-count').textContent=beans.length;
    const total=beans.reduce((a,b)=>a+b.ratio,0);
    this._updateRatioBar(beans,total);
    document.getElementById('kw-ratio-cards').innerHTML=beans.map((b,i)=>{
      const pl=b.price>0?`<span class="kw-rc-price">${new Intl.NumberFormat('tr-TR',{style:'currency',currency:'TRY',maximumFractionDigits:0}).format(b.price)}/kg</span>`:'';
      return `<div class="kw-ratio-card" style="border-left:4px solid ${b.color};"><div class="kw-ratio-card__head"><span class="kw-rc-dot" style="background:${b.color};"></span><div><strong>${b.title}</strong><small>${b.mensei}</small></div>${pl}</div><div class="kw-ratio-card__ctrl"><button class="kw-ratio-btn" data-idx="${i}" data-delta="-10">−</button><span class="kw-ratio-val" id="kw-rv-${i}">%${b.ratio}</span><button class="kw-ratio-btn" data-idx="${i}" data-delta="10">+</button></div></div>`;
    }).join('');
    this._updateTotalBadge(total);
  }
  _updateRatioBar(beans,total){
    const bar=document.getElementById('kw-ratio-bar');if(!bar)return;
    bar.innerHTML=beans.map(b=>`<div style="width:${b.ratio}%;height:100%;background:${b.color};display:inline-block;vertical-align:top;"></div>`).join('')+(total<100?`<div style="width:${100-total}%;height:100%;background:#e74c3c;display:inline-block;vertical-align:top;opacity:.7;"></div>`:'');
  }
  _updateTotalBadge(total){
    const badge=document.getElementById('kw-total-pct');if(!badge)return;
    badge.textContent=`%${total}`;const ok=total===100;badge.style.color=ok?'':'#c0392b';
    const wrap=badge.closest('.kw-total-badge');if(wrap){wrap.style.background=ok?'':'#fdecea';wrap.style.color=ok?'':'#c0392b';}
  }
  _ratio(idx,delta){
    const beans=this._s.beans,target=beans[idx].ratio+delta;
    if(target<10||target>90)return;
    const cur=beans.reduce((a,b)=>a+b.ratio,0),proj=cur-beans[idx].ratio+target;
    if(proj>100)return;
    beans[idx].ratio=target;this._updateRatioBar(beans,proj);this._updateTotalBadge(proj);
    const el=document.getElementById(`kw-rv-${idx}`);if(el)el.textContent=`%${target}`;
    const w=document.getElementById('kw-bean-warning');
    if(w){if(proj!==100){w.textContent=`Oranlar toplamı %${proj} — %100 olmalı.`;w.style.display='block';}else w.style.display='none';}
    this._navBtns();this._summary();this._save();
  }

  _renderRoast(){
    document.querySelectorAll('[data-group="step4-roast"]').forEach(c=>{c.classList.toggle('selected',c.dataset.value===this._s.roast);});
    document.querySelectorAll('[data-group="step4-grind"]').forEach(c=>{c.classList.toggle('selected',c.dataset.value===this._s.grind);});
    const type=this._s.type||'filtre';
    const roastSuggest={filtre:'light',turk:'medium',espresso:'dark'};
    const suggested=roastSuggest[type];
    document.querySelectorAll('[data-group="step4-roast"]').forEach(card=>{card.classList.toggle('kw-roast-suggested',suggested&&card.dataset.value===suggested);});
    const hint=document.getElementById('kw-roast-hint'); if(hint)hint.style.display='none';
    ['turk','filtre','espresso'].forEach(t=>{const el=document.getElementById('kw-grind-'+t);if(el)el.style.display=t===type?'':'none';});
    const validGrinds={turk:['cekirdek','turk'],filtre:['cekirdek','filtre-kaba','filtre-orta','filtre-ince'],espresso:['cekirdek']};
    if(this._s.grind&&!validGrinds[type]?.includes(this._s.grind))this._s.grind=null;
    setTimeout(()=>{
      const rCards=[...document.querySelectorAll('[data-group="step4-roast"]')].filter(el=>el.offsetParent!==null);
      if(rCards.length===1&&!this._s.roast){rCards[0].classList.add('selected');this._s.roast=rCards[0].dataset.value;this._summary();this._navBtns();this._save();}
      const gs=document.getElementById('kw-grind-'+type);
      if(gs){const gc=[...gs.querySelectorAll('[data-group="step4-grind"]')].filter(el=>el.offsetParent!==null);if(gc.length===1&&!this._s.grind){gc[0].classList.add('selected');this._s.grind=gc[0].dataset.value;this._summary();this._navBtns();this._save();}}
    },50);
  }
  _renderStockPanel() { const panel=document.getElementById('kw-stock-panel'); if(panel) panel.style.display='none'; }

  _renderKg(){
    const stockMax=this._maxKgByStock(),dispMax=Math.min(KW_MAX,stockMax);
    if(this._s.quantityKg>dispMax)this._s.quantityKg=dispMax;
    const sw=document.getElementById('kw-stock-warning'); if(sw) sw.style.display='none';
    const presets=document.getElementById('kw-qty-presets');
    if(presets){
      const vis=[10,20,25,40,50,60,75,80,100].filter(v=>v<=dispMax);
      presets.innerHTML=vis.map(v=>`<button class="kw-qty-preset${this._s.quantityKg===v?' active':''}" data-v="${v}">${v} kg</button>`).join('')+`<button class="kw-qty-preset kw-qty-preset--more" data-v="999">Daha fazla →</button>`;
    }
    this._updateQtyDisplay();
  }
  _maxKgByStock(){
    const s=this._s; if(!s.beans.length)return KW_MAX;
    const UNK=9999*1000;
    if(s.character==='single'){const sg=s.beans[0].stockGr;if(sg<=0)return 0;return sg>=UNK?50:Math.min(50,Math.floor(sg/1000));}
    let min=Infinity;
    s.beans.forEach(b=>{if(b.stockGr<=0){min=0;return;}if(b.stockGr>=UNK)return;const r=b.ratio>0?b.ratio/100:0.5;const kg=Math.floor(b.stockGr/1000/r);if(kg<min)min=kg;});
    return min===Infinity?KW_MAX:Math.min(KW_MAX,Math.max(0,min));
  }
  _changeQty(dir){
    const n=this._s.quantityKg+dir*5,stockMax=this._maxKgByStock();
    if(dir>0){if(n>KW_MAX){this._showContact('yuksek_hacim');return;}if(n>stockMax){this._showContact('yetersiz_stok');return;}}
    this._setQty(Math.max(KW_MIN,Math.min(n,stockMax)));
  }
  _setQty(v){
    const mx=this._maxKgByStock();
    if(v>KW_MAX){this._showContact();return;}
    if(v>mx){v=mx;if(v<KW_MIN){kwToast('Yeterli stok yok.','warning');return;}}
    this._s.quantityKg=v;this._s.packages=[];
    this._updateQtyDisplay();this._summary();this._navBtns();this._save();
    const pc=document.getElementById('kw-pkg-rows');if(pc){pc.dataset.built='0';pc.innerHTML='';}
    document.querySelectorAll('.kw-qty-preset').forEach(b=>b.classList.toggle('active',parseInt(b.dataset.v)===v));
  }
  _updateQtyDisplay(){const el=document.getElementById('kw-qty-number');if(el)el.textContent=this._s.quantityKg;}

  _showContact(tip='yuksek_hacim'){
    const modal=document.getElementById('kw-contact-modal'); if(!modal) return;
    modal.dataset.tip=tip;
    const title=modal.querySelector('.kw-contact-title'),sub=modal.querySelector('.kw-contact-sub'),desc=modal.querySelector('.kw-contact-desc');
    const stockMax=this._maxKgByStock();
    if(tip==='yetersiz_stok'){
      if(title)title.textContent='Stok Yetersiz';if(sub)sub.textContent='Talep oluşturun, hazır olunca sizi arayalım';
      if(desc)desc.textContent=`Seçtiğiniz çekirdek için şu an yeterli stok bulunmuyor (mevcut: ${stockMax} kg). İhtiyacınız olan miktarı belirtin, stok hazır olduğunda size ulaşalım.`;
    } else {
      if(title)title.textContent='Toplu Üretim Talebi';if(sub)sub.textContent='100 kg ve üzeri siparişler';
      if(desc)desc.textContent='Büyük hacimli siparişler üretim planlaması gerektirir. Bilgilerinizi ve talep ettiğiniz miktarı bırakın, ekibimiz sizi arasın.';
    }
    const startMiktar=tip==='yetersiz_stok'?Math.ceil((stockMax+5)/5)*5:105;
    let miktarField=document.getElementById('kw-contact-miktar-wrap');
    if(!miktarField){
      const fields=document.querySelector('.kw-contact-fields');
      if(fields){
        const div=document.createElement('div'); div.id='kw-contact-miktar-wrap'; div.className='kw-contact-field';
        div.innerHTML=`<label class="kw-contact-label">Talep Ettiğiniz Miktar (kg) *</label><div style="display:flex;align-items:center;border:1px solid #D4C4A8;border-radius:2px;overflow:hidden;background:#fff;"><button type="button" id="kw-miktar-rem" style="width:44px;height:44px;border:none;background:#f7f5f2;font-size:20px;cursor:pointer;flex-shrink:0;border-right:1px solid #D4C4A8;font-family:inherit;color:#5C5040;">−</button><input type="number" id="kw-contact-miktar" style="flex:1;text-align:center;font-size:16px;font-weight:700;color:#3A3028;border:none;outline:none;padding:0;background:#fff;min-width:0;-moz-appearance:textfield;" value=""><button type="button" id="kw-miktar-add" style="width:44px;height:44px;border:none;background:#f7f5f2;font-size:20px;cursor:pointer;flex-shrink:0;border-left:1px solid #D4C4A8;font-family:inherit;color:#5C5040;">+</button></div>`;
        fields.appendChild(div); miktarField=div;
      }
    }
    const snap5=v=>Math.round(v/5)*5||5;
    const setMiktar=v=>{const inp=document.getElementById('kw-contact-miktar');if(inp)inp.value=v;};
    setMiktar(startMiktar);
    const remBtn=document.getElementById('kw-miktar-rem'),addBtn=document.getElementById('kw-miktar-add');
    if(remBtn)remBtn.onclick=()=>{const inp=document.getElementById('kw-contact-miktar');const cur=snap5(parseInt(inp.value)||startMiktar);setMiktar(Math.max(startMiktar,cur-5));};
    if(addBtn)addBtn.onclick=()=>{const inp=document.getElementById('kw-contact-miktar');const cur=snap5(parseInt(inp.value)||startMiktar);setMiktar(cur+5);};
    setTimeout(()=>{
      const inp=document.getElementById('kw-contact-miktar');
      if(inp&&!inp.dataset.kkmBlur){
        inp.dataset.kkmBlur='1';
        inp.addEventListener('blur',()=>{const v=snap5(parseInt(inp.value)||startMiktar);setMiktar(Math.max(startMiktar,v));});
        inp.addEventListener('keydown',e=>{if(e.key==='Enter'){const v=snap5(parseInt(inp.value)||startMiktar);setMiktar(Math.max(startMiktar,v));}});
      }
    },100);
    modal.classList.add('open');
  }

  async _submitContact(){
    const name=document.getElementById('kw-contact-name')?.value.trim()||'';
    const company=document.getElementById('kw-contact-company')?.value.trim()||'';
    const city=document.getElementById('kw-contact-city')?.value.trim()||'';
    const email=document.getElementById('kw-contact-email')?.value.trim()||'';
    const phone=document.getElementById('kw-contact-phone')?.value.trim()||'';
    const miktar=parseInt(document.getElementById('kw-contact-miktar')?.value)||0;
    if(!name||!company||!city||!email||!phone){kwToast('Lütfen zorunlu alanları doldurun.','warning');return;}
    if(!miktar||miktar<1){kwToast('Talep ettiğiniz miktarı girin.','warning');return;}
    const s=this._s,tip=document.getElementById('kw-contact-modal')?.dataset.tip||'yuksek_hacim';
    try{await fetch(KW_ADMIN+'/talep.php',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({name,company,city,email,phone,tip,secimler:{type:s.type,character:s.character,beans:s.beans.map(b=>({id:b.id,title:b.title,ratio:b.ratio})),roast:s.roast,grind:s.grind,quantityKg:miktar}})});}catch(e){}
    document.getElementById('kw-contact-modal').classList.remove('open');
    kwToast('Talebiniz alındı. En kısa sürede sizinle iletişime geçeceğiz.','success',5000);
  }

  _renderPkgStep(){this._buildPkgRows();this._refreshPkgUI();}
  _buildPkgRows(){
    const cont=document.getElementById('kw-pkg-rows');if(!cont||cont.dataset.built==='1')return;
    cont.dataset.built='1';
    const amb=this.data.packages||{};
    const sizeHasStock={};
    Object.values(amb).forEach(p=>{const sz=p.ebat_gr||0;if(!sz)return;if((p.stock??9999)>0)sizeHasStock[sz]=true;});
    cont.innerHTML=[250,1000,2500,5000].filter(sz=>sizeHasStock[sz]).map(sz=>{
      const lb=KW_PKG[sz]?.label||sz+'gr';
      // Fiyat aralığı hesapla
      const ambsForSz = Object.values(this.data.packages||{}).filter(p=>(p.ebat_gr||0)===sz&&(p.stock??9999)>0);
      const prices = ambsForSz.map(p=>parseFloat(p.price)||0).filter(v=>v>0);
      const fmtPkg = v=>new Intl.NumberFormat('tr-TR',{style:'currency',currency:this.cfg?.currency||'TRY',maximumFractionDigits:0}).format(v);
      let priceLbl = '';
      if(prices.length===0) priceLbl='<span id="kw-pkg-price-'+sz+'" style="font-size:11px;color:#9A8968;">Ücretsiz</span>';
      else if(prices.length===1||Math.min(...prices)===Math.max(...prices)) priceLbl=`<span id="kw-pkg-price-${sz}" style="font-size:11px;font-weight:600;color:#5C5040;">${fmtPkg(prices[0])}/adet</span>`;
      else priceLbl=`<span id="kw-pkg-price-${sz}" style="font-size:11px;font-weight:600;color:#5C5040;">${fmtPkg(Math.min(...prices))}–${fmtPkg(Math.max(...prices))}/adet</span>`;
      return `<div class="kw-pkg-row" id="kw-pkg-row-${sz}"><div class="kw-pkg-row__pkg-visual"><div class="kw-pkg-mini"><span>${KW_PKG[sz]?.short||sz}</span></div></div><div class="kw-pkg-row__info"><strong>${lb}</strong> ${priceLbl}<small id="kw-pkg-info-${sz}" style="display:block;margin-top:2px;">0 paket</small></div><div class="kw-pkg-row__ctrl"><button class="kw-pkg-rem" data-size="${sz}" id="kw-pkg-rem-${sz}">−</button><input class="kw-pkg-cnt-input" type="number" min="0" value="0" data-size="${sz}" id="kw-pkg-inp-${sz}"><button class="kw-pkg-add" data-size="${sz}" id="kw-pkg-add-${sz}">+</button></div></div>`;
    }).join('');
    if(!cont.innerHTML.trim())cont.innerHTML='<p class="kw-empty">Stokta ambalaj bulunmuyor.</p>';
    [250,1000,2500,5000].forEach(sz=>{
      const inp=document.getElementById('kw-pkg-inp-'+sz);
      if(inp){const sync=()=>{const v=Math.max(0,parseInt(inp.value)||0);inp.value=v;this._setPkgCount(sz,v);};inp.addEventListener('change',sync);inp.addEventListener('blur',sync);}
    });
  }
  _setPkgCount(sz,val){
    val=Math.max(0,parseInt(val)||0);
    const totalGr=this._s.quantityKg*1000,otherGr=this._s.packages.filter(p=>p.sizeGr!==sz).reduce((a,p)=>a+p.sizeGr*p.count,0);
    const maxByWeight=sz>0?Math.floor((totalGr-otherGr)/sz):0;
    const ambId=this._s.pkgDesigns?.[sz],amb=ambId?this.data.packages[ambId]:null;
    const ambStock=amb&&(amb.stock??9999)<9999?amb.stock:99999;
    val=Math.min(val,maxByWeight,ambStock); val=Math.max(0,val);
    const ex=this._s.packages.find(p=>p.sizeGr===sz);
    if(val===0)this._s.packages=this._s.packages.filter(p=>p.sizeGr!==sz);
    else if(ex)ex.count=val;
    else this._s.packages.push({sizeGr:sz,count:val});
    this._refreshPkgUI();
  }
  _pkgAdd(sz){
    const ex=this._s.packages.find(p=>p.sizeGr===sz),cur=ex?.count||0;
    const ambId=this._s.pkgDesigns?.[sz],amb=ambId?this.data.packages[ambId]:null;
    const ambStock=amb&&(amb.stock??9999)<9999?amb.stock:99999;
    if(cur>=ambStock){kwToast(`Bu ambalajdan en fazla ${ambStock} adet eklenebilir.`,'warning');return;}
    this._setPkgCount(sz,cur+1);
  }
  _pkgRem(sz){const ex=this._s.packages.find(p=>p.sizeGr===sz);this._setPkgCount(sz,Math.max(0,(ex?.count||0)-1));}

  _refreshPkgUI(){
    const s=this._s;
    const totalGr=s.quantityKg*1000,usedGr=s.packages.reduce((a,p)=>a+p.sizeGr*p.count,0),remGr=totalGr-usedGr,pct=Math.min(100,(usedGr/totalGr)*100);
    const bw=document.getElementById('kw-pkg-bar-wrap');
    if(bw){
      const rem=Math.max(0,100-pct);
      const cols={250:'#9B5B30',1000:'#7D4A2A',2500:'#5C3217',5000:'#3A1D0C'};
      const segs=s.packages.filter(p=>p.count>0).map(p=>`<div style="width:${(p.sizeGr*p.count/totalGr)*100}%;height:100%;background:${cols[p.sizeGr]||'#B08968'};display:flex;align-items:center;justify-content:center;"><span style="font-size:10px;color:#fff;font-weight:600;overflow:hidden;padding:0 4px;">${KW_PKG[p.sizeGr]?.short}</span></div>`).join('');
      const red=rem>0?`<div style="width:${rem}%;height:100%;background:#e74c3c;opacity:.35;border-radius:${pct===0?'8px':'0 8px 8px 0'};display:flex;align-items:center;justify-content:center;">${pct===0?'<span style="font-size:11px;color:#c0392b;font-weight:600;">Paket seçilmedi</span>':''}</div>`:'';
      bw.innerHTML=`<div style="display:flex;height:100%;border-radius:8px;overflow:hidden;">${segs}${red}</div>`;
    }
    const lbl=document.getElementById('kw-pkg-progress-label');if(lbl)lbl.textContent=`${this._grLbl(usedGr)} / ${s.quantityKg} kg`;
    const badge=document.getElementById('kw-pkg-badge');
    if(badge){
      if(usedGr===totalGr){
        const wasComplete=badge.dataset.complete==='1';
        badge.textContent='Tamamlandı ✓';badge.style.background='#ebf5ee';badge.style.color='#27ae60';
        if(!wasComplete){badge.dataset.complete='1';kwConfetti(document.getElementById('kw-pkg-bar-wrap'));}
      } else {
        if(badge.dataset.complete)delete badge.dataset.complete;
        if(usedGr>totalGr){badge.textContent='Fazla seçtiniz';badge.style.background='#fdecea';badge.style.color='#c0392b';}
        else{badge.textContent=`${this._grLbl(totalGr-usedGr)} eksik`;badge.style.background='#fdecea';badge.style.color='#c0392b';}
      }
    }
    const warn=document.getElementById('kw-pkg-warning');
    if(warn){if(remGr===0)warn.style.display='none';else{warn.style.display='block';warn.textContent=remGr>0?`${this._grLbl(remGr)} daha eklemeniz gerekiyor.`:`${this._grLbl(-remGr)} fazla seçtiniz.`;}}
    [250,1000,2500,5000].forEach(sz=>{
      const ex=s.packages.find(p=>p.sizeGr===sz),cnt=ex?.count||0;
      const inp=document.getElementById('kw-pkg-inp-'+sz),info=document.getElementById('kw-pkg-info-'+sz),row=document.getElementById('kw-pkg-row-'+sz),rb=document.getElementById('kw-pkg-rem-'+sz);
      if(inp)inp.value=cnt;if(info)info.textContent=cnt>0?cnt+' paket — '+this._grLbl(sz*cnt):'0 paket';if(row)row.classList.toggle('kw-pkg-row--selected',cnt>0);if(rb)rb.disabled=cnt===0;
    });
    // Adım 6 alt özet gizle — fiyat paket satırında gösteriliyor
    const feeSum=document.getElementById('kw-pkg-fee-summary');
    if(feeSum) feeSum.style.display='none';
    this._navBtns();this._summary();this._save();
  }
  _grLbl(gr){return gr>=1000?`${gr/1000} kg`:`${gr} gr`;}

  _renderAmbalajStep(){
    const s=this._s,cont=document.getElementById('kw-ambalaj-step');if(!cont)return;
    const active=(s.packages||[]).filter(p=>p.count>0).sort((a,b)=>a.sizeGr-b.sizeGr);
    if(!active.length){cont.innerHTML='<p class="kw-empty">Önce paket adedi seçin (Adım 6).</p>';return;}
    const bySize={};
    this.catalog.ambalajlar.forEach(a=>{const sz=a.ebat_gr;if(!bySize[sz])bySize[sz]=[];bySize[sz].push(a);});
    cont.innerHTML=active.map(pkg=>{
      const sl=KW_PKG[pkg.sizeGr]?.label||pkg.sizeGr+'gr';
      const cur=s.pkgDesigns[pkg.sizeGr]||'';
      const list=(bySize[pkg.sizeGr]||[]).filter(a=>a.stock>0);
      if(!list.length)return `<div class="kw-ambalaj-section" style="margin-bottom:28px;"><div class="kw-amb-section-header"><span class="kw-amb-size-badge">${sl}</span></div><p class="kw-empty">Bu ebat için ambalaj yok.</p></div>`;
      const cards=list.map(a=>{
        const sel=cur===a.ambId;
        const img1=a.imgs[0]||'',img2=a.imgs[1]||img1;
        // ── PATCH 5: Ambalaj kartı fiyat etiketi ──
        const fmtAmb=v=>new Intl.NumberFormat('tr-TR',{style:'currency',currency:this.cfg?.currency||'TRY',maximumFractionDigits:0}).format(v);
        const priceLblAmb=a.price>0
          ?`<div style="font-size:11px;font-weight:700;color:#5C5040;margin-top:4px;background:#f4f0ea;padding:2px 8px;border-radius:20px;display:inline-block;">${fmtAmb(a.price)}<span style="font-weight:400;font-size:10px;color:#9A8968;">/adet</span></div>`
          :`<div style="font-size:11px;font-weight:700;color:#2E7D52;margin-top:4px;background:#edf7f0;padding:2px 8px;border-radius:20px;display:inline-block;">Ücretsiz</div>`;
        return `<div class="kw-amb-card kw-amb-card--photo${sel?' kw-amb-card--selected':''}" data-size="${pkg.sizeGr}" data-type="${a.ambId}" style="cursor:pointer;"
          ${img2&&img2!==img1?`onmouseenter="this.querySelector('.kw-amb-img-main').style.opacity=0;this.querySelector('.kw-amb-img-hover').style.opacity=1;" onmouseleave="this.querySelector('.kw-amb-img-main').style.opacity=1;this.querySelector('.kw-amb-img-hover').style.opacity=0;"`:''}>
          <div style="position:relative;height:72px;overflow:hidden;background:#f5f0e8;">
            ${img1?`<img class="kw-amb-img-main" src="${img1}" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover;transition:opacity .2s;"><img class="kw-amb-img-hover" src="${img2}" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover;opacity:0;transition:opacity .2s;">`:''}
            ${sel?'<span style="position:absolute;top:4px;right:4px;width:16px;height:16px;background:#1C1812;color:#fff;font-size:9px;display:flex;align-items:center;justify-content:center;font-weight:700;z-index:2;">✓</span>':''}
          </div>
          <div style="padding:6px 7px;"><div style="font-size:11px;font-weight:600;color:#1C1812;margin-bottom:2px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${a.isim}</div><div style="font-size:9px;color:#9A8968;">${a.tur}</div><div style="font-size:9px;color:#B08968;">${a.ebat}</div>${priceLblAmb}</div>
        </div>`;
      }).join('');
      const curName=list.find(a=>a.ambId===cur)?.isim||'';
      return `<div class="kw-ambalaj-section" style="margin-bottom:28px;"><div class="kw-amb-section-header"><span class="kw-amb-size-badge">${sl}</span><span class="kw-amb-count">${pkg.count} paket</span>${cur?`<span class="kw-amb-selected-label">✓ ${curName}</span>`:'<span class="kw-amb-warn">Seçilmedi</span>'}</div><div class="kw-amb-grid kw-amb-grid--6">${cards}</div></div>`;
    }).join('');
    Object.entries(bySize).forEach(([sz,list])=>{
      const aktif=list.filter(a=>a.stock>0),szN=parseInt(sz);
      if(aktif.length===1&&!s.pkgDesigns[szN]) s.pkgDesigns[szN]=aktif[0].ambId;
    });
    if(!cont.dataset.autoSelected){
      cont.dataset.autoSelected='1';
      const changed=Object.keys(bySize).some(sz=>!s.pkgDesigns[parseInt(sz)]&&(bySize[sz]||[]).filter(a=>a.stock>0).length===1);
      if(changed){this._navBtns();this._summary();this._save();this._renderAmbalajStep();return;}
    }
    cont.querySelectorAll('.kw-amb-card').forEach(card=>{
      card.addEventListener('click',()=>{
        const sz=parseInt(card.dataset.size),ambId=card.dataset.type;
        s.pkgDesigns[sz]=ambId;
        const amb=this.data.packages[ambId];
        const ambStock=amb&&(amb.stock??9999)<9999?amb.stock:99999;
        const ex=s.packages.find(p=>p.sizeGr===sz);
        if(ex&&ex.count>ambStock){ex.count=ambStock;kwToast(`Bu ambalajdan en fazla ${ambStock} adet stokta var.`,'warning');}
        this._navBtns();this._summary();this._save();this._renderAmbalajStep();
        setTimeout(()=>{
          const sections=[...document.querySelectorAll('.kw-ambalaj-section')];
          const curIdx=sections.findIndex(s=>s.querySelector(`[data-size="${sz}"]`));
          if(curIdx>=0&&curIdx<sections.length-1) sections[curIdx+1].scrollIntoView({behavior:'smooth',block:'start'});
          else if(this._pkgDesignsOk()) setTimeout(()=>this.next(),300);
        },150);
      });
    });
    const lw=document.getElementById('kw-logo-section-7');
    if(lw){
      lw.style.display='block';
      document.querySelectorAll('[data-group="step7-logo-design"]').forEach(c=>{c.classList.toggle('selected',c.dataset.value===s.designType);});
      const uploadDiv=document.getElementById('kw-logo-upload-7');
      if(uploadDiv) uploadDiv.style.display=s.designType==='custom'?'block':'none';
      if(s.designType==='custom'){
        const inp=document.getElementById('kw-logo-file'); if(inp&&!inp.dataset.kkmInit) this._initLogoUpload();
        if(s.logoUrl){const prev=document.getElementById('kw-logo-preview');if(prev&&prev.style.display==='none')this._renderLogoPreview(s.logoUrl,s.logoFile||'logo');}
      }
    }
  }

  _renderPreview(){
    if(this._s.designType)document.querySelector(`[data-group="step8-design"][data-value="${this._s.designType}"]`)?.classList.add('selected');
    this._renderOrderPreview();
    this._renderTaksitTablosu();
  }

  async _renderTaksitTablosu(){
    const el=document.getElementById('kw-taksit-cards'); if(!el) return;
    const s=this._s;
    let total=0;
    s.beans.forEach(b=>{const kg=s.character==='single'?s.quantityKg:s.quantityKg*b.ratio/100;total+=(b.price||0)*kg;});
    // ── PATCH 6: Taksit ambalaj fiyatı ──
    const pkgCount=(s.packages||[]).reduce((a,p)=>a+p.count,0);
    (s.packages||[]).filter(p=>p.count>0).forEach(pkg=>{
      const ambId=s.pkgDesigns?.[pkg.sizeGr];
      const amb=ambId?this.catalog.ambalajlar.find(a=>a.ambId===ambId):null;
      if(amb?.price>0) total+=amb.price*pkg.count;
    });
    if(s.designType==='custom') total+=pkgCount*35;
    if(total<1){el.innerHTML='';return;}
    const amountKurus=Math.round(total*100);
    el.innerHTML=`<div style="font-size:12px;color:var(--kw-muted);padding:8px 0;">Taksit seçenekleri yükleniyor...</div>`;
    try {
      const res=await fetch(KW_ADMIN+'/paytr-taksit.php?amount='+amountKurus,{cache:'no-store'});
      const data=await res.json();
      if(data.error||!data.card_family_rates){el.innerHTML='';return;}
      const families={};
      (data.card_family_rates||[]).forEach(cf=>{
        if(!families[cf.card_family_name])families[cf.card_family_name]=[];
        (cf.installments||[]).forEach(inst=>{families[cf.card_family_name].push(inst);});
      });
      const firstFamily=Object.values(families)[0]||[];
      if(!firstFamily.length){el.innerHTML='';return;}
      const fmt=v=>new Intl.NumberFormat('tr-TR',{style:'currency',currency:'TRY',maximumFractionDigits:2}).format(v/100);
      const rows=firstFamily.map(inst=>{
        const n=inst.installment_count,monthly=inst.installment_price,totalInst=inst.total_price,extra=totalInst-amountKurus,isFree=extra<=10;
        return `<tr><td style="padding:10px 12px;border-bottom:1px solid var(--kw-line);font-size:13px;font-weight:600;">${n===1?'Tek Çekim':n+' Taksit'}</td><td style="padding:10px 12px;border-bottom:1px solid var(--kw-line);font-size:13px;">${fmt(monthly)}<small style="color:var(--kw-muted);font-size:11px;">/ay</small></td><td style="padding:10px 12px;border-bottom:1px solid var(--kw-line);font-size:13px;">${fmt(totalInst)}</td><td style="padding:10px 12px;border-bottom:1px solid var(--kw-line);font-size:12px;color:${isFree?'var(--kw-green)':'var(--kw-muted)'};">${isFree?'Ücretsiz':'+'+fmt(extra)}</td></tr>`;
      }).join('');
      el.innerHTML=`<div style="margin-top:24px;"><div class="kw-section-label" style="margin-bottom:10px;">TAKSİT SEÇENEKLERİ</div><div style="overflow-x:auto;"><table style="width:100%;border-collapse:collapse;font-size:13px;"><thead><tr style="background:var(--kw-bg2);"><th style="padding:8px 12px;text-align:left;font-size:10px;letter-spacing:.08em;color:var(--kw-taupe);font-weight:700;border-bottom:2px solid var(--kw-line);">TAKSİT</th><th style="padding:8px 12px;text-align:left;font-size:10px;letter-spacing:.08em;color:var(--kw-taupe);font-weight:700;border-bottom:2px solid var(--kw-line);">AYLIK</th><th style="padding:8px 12px;text-align:left;font-size:10px;letter-spacing:.08em;color:var(--kw-taupe);font-weight:700;border-bottom:2px solid var(--kw-line);">TOPLAM</th><th style="padding:8px 12px;text-align:left;font-size:10px;letter-spacing:.08em;color:var(--kw-taupe);font-weight:700;border-bottom:2px solid var(--kw-line);">FARK</th></tr></thead><tbody>${rows}</tbody></table></div><p style="font-size:10px;color:var(--kw-muted);margin-top:8px;">* Taksit seçenekleri kullandığınız karta göre değişebilir.</p></div>`;
    } catch(e) { el.innerHTML=''; }
  }

  _renderOrderPreview(){
    const s=this._s,el=document.getElementById('kw-order-preview');if(!el)return;
    const fmt=v=>new Intl.NumberFormat('tr-TR',{style:'currency',currency:this.cfg?.currency||'TRY',maximumFractionDigits:0}).format(v);

    // Çekirdek satırları
    let bTotal=0;
    const beanRows=s.beans.map(b=>{
      const kg=s.character==='single'?s.quantityKg:+(s.quantityKg*b.ratio/100).toFixed(2);
      const cost=(b.price||0)*kg;
      bTotal+=cost;
      const ratioStr=s.character==='single'?'':`<span style="color:#9A8968;margin:0 6px;">%${b.ratio}·${kg}kg</span>`;
      const priceStr=cost>0?`<strong style="color:#3A3028;">${fmt(cost)}</strong>`:'';
      return `<div style="display:flex;justify-content:space-between;align-items:center;padding:10px 18px;border-bottom:1px solid #F7F5F2;font-size:13px;">
        <span style="display:flex;align-items:center;gap:7px;"><span style="width:8px;height:8px;border-radius:50%;background:${b.color};display:inline-block;flex-shrink:0;"></span><span style="color:#5C5040;">${b.title}</span>${ratioStr}</span>
        ${priceStr}
      </div>`;
    }).join('');
    const bTotalRow=bTotal>0?`<div style="display:flex;justify-content:space-between;padding:8px 18px;border-bottom:1px solid #E8DDD0;font-size:13px;background:#faf8f5;"><strong style="color:#5C5040;">Kahve toplamı</strong><strong>${fmt(bTotal)}</strong></div>`:'';

    // Ambalaj satırları
    let pkgTotal=0;
    const pkgRows=(s.packages||[]).filter(p=>p.count>0).map(p=>{
      const ambId=s.pkgDesigns?.[p.sizeGr];
      const amb=ambId?this.catalog.ambalajlar.find(a=>a.ambId===ambId):null;
      const price=amb?.price||0;
      pkgTotal+=price*p.count;
      const lbl=KW_PKG[p.sizeGr]?.label||'';
      const ambName=amb?.isim?` — ${amb.isim}`:'';
      const priceStr=price>0?`<strong>${fmt(price*p.count)}</strong>`:`<strong style="color:#2E7D52;">Ücretsiz</strong>`;
      return `<div style="display:flex;justify-content:space-between;align-items:center;padding:10px 18px;border-bottom:1px solid #F7F5F2;font-size:13px;">
        <span style="color:#5C5040;">${p.count}× ${lbl}${ambName}</span>${priceStr}
      </div>`;
    }).join('');

    // Logo
    const pc=s.packages?.reduce((a,p)=>a+p.count,0)||0;
    const lf=s.designType==='custom'?pc*35:0;
    const logoRow=lf>0?`<div style="display:flex;justify-content:space-between;align-items:center;padding:10px 18px;border-bottom:1px solid #F7F5F2;font-size:13px;">
      <span style="color:#5C5040;">Logo Uygulaması (${pc} adet)</span><strong>+${fmt(lf)}</strong>
    </div>`:'';

    // Logo önizleme
    const logoPreview=s.designType==='custom'&&s.logoUrl?`<div style="display:flex;justify-content:space-between;align-items:flex-start;padding:10px 18px;border-bottom:1px solid #F7F5F2;font-size:13px;">
      <span style="color:#9A8968;">Logo Dosyası</span>
      <div style="text-align:right;"><img src="${s.logoUrl}" style="max-width:100px;max-height:60px;object-fit:contain;border:1px solid #e8e0d0;padding:4px;background:#fff;display:block;margin-left:auto;"><span style="font-size:10px;color:#9A8968;display:block;margin-top:3px;">${s.logoFile||''}</span></div>
    </div>`:'';

    // Toplam
    const total=bTotal+pkgTotal+lf;
    const totalRow=total>0?`<div style="display:flex;justify-content:space-between;align-items:center;padding:12px 18px;font-size:14px;">
      <strong style="letter-spacing:.04em;color:#9A8968;font-size:11px;text-transform:uppercase;">Tahmini Toplam</strong>
      <strong style="font-size:18px;color:#3A3028;">${fmt(total)}</strong>
    </div>`:'';

    el.innerHTML=`<div class="kw-preview-card">
      <div class="kw-preview-row"><span>Kahve Türü</span><strong>${this._typeL(s.type)}</strong></div>
      <div class="kw-preview-row"><span>Kavurma</span><strong>${this._roastL(s.roast)}</strong></div>
      <div class="kw-preview-row"><span>Öğütme</span><strong>${this._grindL(s.grind)}</strong></div>
      <div class="kw-preview-row"><span>Miktar</span><strong>${s.quantityKg} kg</strong></div>
    </div>
    <div class="kw-preview-card" style="margin-top:12px;">
      <div style="padding:10px 18px;font-size:10px;font-weight:700;letter-spacing:.1em;color:#9A8968;border-bottom:1px solid #E8DDD0;text-transform:uppercase;">ÇEKİRDEKLER</div>
      ${beanRows}${bTotalRow}
    </div>
    <div class="kw-preview-card" style="margin-top:12px;">
      <div style="padding:10px 18px;font-size:10px;font-weight:700;letter-spacing:.1em;color:#9A8968;border-bottom:1px solid #E8DDD0;text-transform:uppercase;">AMBALAJ & TASARIM</div>
      ${pkgRows}${logoRow}${logoPreview}
    </div>
    ${total>0?`<div class="kw-preview-card" style="margin-top:12px;">${totalRow}</div>`:''}`;
    this._price();
  }

  _summary(){
    const s=this._s;
    this._txt('kw-sum-type',this._typeL(s.type));
    this._txt('kw-sum-char',this._charL(s.character));
    this._txt('kw-sum-roast',this._roastL(s.roast));
    this._txt('kw-sum-grind',this._grindL(s.grind));
    this._txt('kw-sum-qty',s.quantityKg?`${s.quantityKg} kg`:'—');
    this._renderSummaryBoxes();
    const pw=document.getElementById('kw-sum-pkg-wrap'),pe=document.getElementById('kw-sum-pkg-detail');
    const pkgs=(s.packages?.filter(p=>p.count>0)||[]).sort((a,b)=>a.sizeGr-b.sizeGr);
    if(pe&&pw){
      if(pkgs.length){
        pw.style.display='block';
        const al=document.getElementById('kw-acc-ambalaj');if(al)al.style.display='';
        const amb=this.data.packages||{};
        pe.innerHTML=pkgs.map(p=>{
          const did=s.pkgDesigns?.[p.sizeGr]||'',an=did&&amb[did]?.isim?amb[did].isim:'';
          const sl=KW_PKG[p.sizeGr]?.label||'',ll=an?`${sl} — ${an}`:sl;
          return `<div style="display:flex;justify-content:space-between;align-items:center;padding:7px 0;border-bottom:1px solid var(--kw-line);font-size:12px;gap:8px;"><span>${ll}</span><span style="color:var(--kw-muted);">${p.count} adet</span></div>`;
        }).join('');
      } else {pw.style.display='none';const al=document.getElementById('kw-acc-ambalaj');if(al)al.style.display='none';}
    }
    const dw=document.getElementById('kw-sum-design-wrap');
    if(dw) dw.style.display='none';
    const bs=document.getElementById('kw-sum-beans');
    if(s.beans.length){
      if(bs)bs.style.display='block';
      const bl=document.getElementById('kw-sum-bean-list');
      if(bl)bl.innerHTML=s.beans.map(b=>`<div class="kw-sum-bean-row"><span class="kw-sum-bean-dot" style="background:${b.color}"></span><span>${b.title}</span>${s.character!=='single'?`<span class="kw-sum-bean-ratio" style="color:${b.color}">%${b.ratio}</span>`:''}</div>`).join('');
      const bar=document.getElementById('kw-sum-bean-bar');
      if(bar){if(s.character!=='single'&&s.beans.length>1){let cum=0;bar.style.background=`linear-gradient(to right,${s.beans.map(b=>{const p=`${b.color} ${cum}% ${cum+b.ratio}%`;cum+=b.ratio;return p;}).join(',')})`;bar.style.display='block';}else bar.style.display='none';}
    } else if(bs)bs.style.display='none';
    this._price();
    const sb=document.getElementById('kw-save-blend');
    if(sb){sb.style.display=s.beans.length?'block':'none';if(!sb.dataset.r){sb.innerHTML=`<div style="background:#5C5040;color:#FAFAF8;padding:12px 16px;font-size:11px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:8px;width:100%;user-select:none;">💾 Harmanı Kaydet</div>`;sb.dataset.r='1';}}
  }

  _renderSummaryBoxes(){
    const s=this._s;
    const fmt=v=>new Intl.NumberFormat('tr-TR',{style:'currency',currency:this.cfg?.currency||'TRY',maximumFractionDigits:0}).format(v);
    const box=(title,content)=>`<div style="border:1px solid var(--kw-line);margin-bottom:8px;"><div style="font-size:9px;font-weight:700;letter-spacing:.1em;color:var(--kw-taupe);padding:7px 12px;border-bottom:1px solid var(--kw-line);background:var(--kw-bg2);text-transform:uppercase;">${title}</div><div style="padding:4px 0;">${content}</div></div>`;
    const row=(label,val,color)=>`<div style="display:flex;justify-content:space-between;align-items:center;padding:7px 12px;border-bottom:1px solid var(--kw-bg2);font-size:12px;"><span style="color:var(--kw-muted);">${label}</span><span style="font-weight:600;color:${color||'var(--kw-dark)'};">${val}</span></div>`;

    // Genel bilgi kutusu
    if(!s.type) return;
    let genelRows='';
    genelRows+=row('Tür',this._typeL(s.type));
    if(s.character) genelRows+=row('Karakter',this._charL(s.character));
    if(s.roast) genelRows+=row('Kavurma',this._roastL(s.roast));
    if(s.grind) genelRows+=row('Öğütme',this._grindL(s.grind));
    if(s.quantityKg) genelRows+=row('Miktar',s.quantityKg+' kg');

    // Çekirdek kutusu
    let beanBox='';
    if(s.beans?.length){
      let bTotal=0;
      let beanRows=s.beans.map(b=>{
        const kg=s.character==='single'?s.quantityKg:+(s.quantityKg*(b.ratio/100)).toFixed(2);
        const cost=(b.price||0)*kg;
        bTotal+=cost;
        const ratioStr=s.character==='single'?'':`<span style="color:#9A8968;font-size:11px;"> %${b.ratio}</span>`;
        const priceStr=cost>0?`<span style="font-weight:700;">${fmt(cost)}</span>`:'';
        return `<div style="display:flex;justify-content:space-between;align-items:center;padding:7px 12px;border-bottom:1px solid var(--kw-bg2);font-size:12px;gap:4px;">
          <span style="display:flex;align-items:center;gap:5px;min-width:0;"><span style="width:7px;height:7px;border-radius:50%;background:${b.color};flex-shrink:0;display:inline-block;"></span><span style="color:var(--kw-dark);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${b.title}</span>${ratioStr}</span>
          ${priceStr}
        </div>`;
      }).join('');
      if(bTotal>0) beanRows+=`<div style="display:flex;justify-content:space-between;padding:7px 12px;font-size:12px;background:#faf8f5;"><span style="font-weight:600;color:var(--kw-dark);">Toplam</span><span style="font-weight:700;">${fmt(bTotal)}</span></div>`;
      beanBox=box('Çekirdekler',beanRows);
    }

    // Ambalaj kutusu
    let ambBox='';
    const pkgs=(s.packages||[]).filter(p=>p.count>0);
    if(pkgs.length){
      let pkgTotal2=0;
      let pkgRows=pkgs.map(p=>{
        const ambId=s.pkgDesigns?.[p.sizeGr];
        const amb=ambId?this.catalog.ambalajlar.find(a=>a.ambId===ambId):null;
        const price=amb?.price||0;
        pkgTotal2+=price*p.count;
        const lbl=KW_PKG[p.sizeGr]?.label||'';
        const ambName=amb?.isim?` — ${amb.isim}`:'';
        const priceStr=price>0?`<span style="font-weight:700;">${fmt(price*p.count)}</span>`:`<span style="font-weight:700;color:#2E7D52;">Ücretsiz</span>`;
        return `<div style="display:flex;justify-content:space-between;align-items:center;padding:7px 12px;border-bottom:1px solid var(--kw-bg2);font-size:12px;"><span style="color:var(--kw-dark);">${p.count}× ${lbl}${ambName}</span>${priceStr}</div>`;
      }).join('');
      const pc=(s.packages||[]).reduce((a,p)=>a+p.count,0);
      const lf=s.designType==='custom'?pc*35:0;
      if(lf>0) pkgRows+=`<div style="display:flex;justify-content:space-between;align-items:center;padding:7px 12px;border-bottom:1px solid var(--kw-bg2);font-size:12px;"><span style="color:var(--kw-dark);">Logo Uygulaması (${pc} adet)</span><span style="font-weight:700;">+${fmt(lf)}</span></div>`;
      if(pkgTotal2>0||lf>0){
        const ambTot=pkgTotal2+lf;
        pkgRows+=`<div style="display:flex;justify-content:space-between;padding:7px 12px;font-size:12px;background:#faf8f5;"><span style="font-weight:600;color:var(--kw-dark);">Toplam</span><span style="font-weight:700;">${fmt(ambTot)}</span></div>`;
      }
      ambBox=box('Ambalaj & Tasarım',pkgRows);
    }

    // Toplam kutusu
    let totalBox='';
    if(s.beans?.length&&s.quantityKg){
      let bTotal2=0;
      s.beans.forEach(b=>{const kg=s.character==='single'?s.quantityKg:+(s.quantityKg*(b.ratio/100)).toFixed(2);bTotal2+=(b.price||0)*kg;});
      let pkgTotal3=0;
      (s.packages||[]).filter(p=>p.count>0).forEach(pkg=>{const ambId=s.pkgDesigns?.[pkg.sizeGr];const amb=ambId?this.catalog.ambalajlar.find(a=>a.ambId===ambId):null;if(amb?.price>0)pkgTotal3+=amb.price*pkg.count;});
      const pc2=(s.packages||[]).reduce((a,p)=>a+p.count,0);
      const lf2=s.designType==='custom'?pc2*35:0;
      const total2=bTotal2+pkgTotal3+lf2;
      if(total2>0) totalBox=`<div style="border:1px solid var(--kw-line);margin-bottom:8px;"><div style="display:flex;justify-content:space-between;align-items:baseline;padding:12px;"><span style="font-size:10px;font-weight:700;letter-spacing:.1em;color:var(--kw-taupe);text-transform:uppercase;">TAHMİNİ TUTAR</span><span style="font-size:18px;font-weight:700;color:var(--kw-darker);">${fmt(total2)}</span></div></div>`;
    }

    // Render — mevcut summary içeriğini güncelle
    const summaryBox=document.getElementById('kw-summary-boxes');
    if(!summaryBox) return;
    summaryBox.innerHTML=box('Sipariş Bilgileri',genelRows)+beanBox+ambBox+totalBox;
  }

  _price(){
    const s=this._s;
    if(!s.quantityKg||!s.beans.length){['kw-sum-price','kw-sum-bean-fee','kw-sum-pkg-fee','kw-sum-logo-fee','kw-sum-mini-total'].forEach(id=>{const el=document.getElementById(id);if(el)el.style.display='none';});return;}
    const fmt=v=>new Intl.NumberFormat('tr-TR',{style:'currency',currency:this.cfg.currency||'TRY',maximumFractionDigits:0}).format(v);
    let bTotal=0;const bd=[];
    s.beans.forEach(b=>{const kg=s.character==='single'?s.quantityKg:+(s.quantityKg*b.ratio/100).toFixed(2);const cost=(b.price||0)*kg;bTotal+=cost;if(s.character==='blend')bd.push({title:b.title,ratio:b.ratio,kg,cost,color:b.color});});
    // ── PATCH 2: Ambalaj fiyatı hesapla ──
    let pkgTotal=0;
    (s.packages||[]).filter(p=>p.count>0).forEach(pkg=>{
      const ambId=s.pkgDesigns?.[pkg.sizeGr];
      const amb=ambId?this.catalog.ambalajlar.find(a=>a.ambId===ambId):null;
      if(amb?.price>0) pkgTotal+=amb.price*pkg.count;
    });
    const pc=s.packages?.reduce((a,p)=>a+p.count,0)||0,lf=s.designType==='custom'?pc*35:0,total=bTotal+pkgTotal+lf;
    const pd=document.getElementById('kw-sum-price');if(pd)pd.style.display=total>0?'block':'none';
    const te=document.getElementById('kw-sum-total');if(te)te.textContent=fmt(total);
    const be=document.getElementById('kw-sum-bean-fee');
    if(be){if(bTotal>0){be.style.display='block';if(s.character==='blend'&&bd.length>1){be.innerHTML=bd.map(b=>`<div style="display:flex;justify-content:space-between;font-size:11px;padding:4px 0;border-bottom:1px solid var(--kw-line);gap:6px;"><span style="display:flex;align-items:center;gap:5px;"><span style="width:8px;height:8px;background:${b.color};display:inline-block;border-radius:50%;"></span><span>${b.title}</span></span><span>%${b.ratio}·${b.kg}kg</span><span style="font-weight:600;">${fmt(b.cost)}</span></div>`).join('')+`<div style="display:flex;justify-content:space-between;font-size:12px;padding:7px 0 3px;border-top:1px solid var(--kw-line2);"><span style="font-weight:600;">Kahve toplamı</span><span style="font-weight:700;">${fmt(bTotal)}</span></div>`;}else be.innerHTML=`<div style="display:flex;justify-content:space-between;font-size:12px;padding:3px 0;"><span>Kahve (${s.quantityKg} kg)</span><span style="font-weight:600;">${fmt(bTotal)}</span></div>`;}else be.style.display='none';}
    // ── Ozet panel ambalaj satiri (ucretli + ucretsiz ayri) ──
    const pe2=document.getElementById('kw-sum-pkg-fee');
    if(pe2){
      const pkgRows=(s.packages||[]).filter(p=>p.count>0).map(p=>{
        const ambId=s.pkgDesigns?.[p.sizeGr];
        const amb=ambId?this.catalog.ambalajlar.find(a=>a.ambId===ambId):null;
        const lbl=KW_PKG[p.sizeGr]?.label||p.sizeGr+'gr';
        return {...p,unitPrice:amb?.price||0,lbl};
      });
      const paidRows=pkgRows.filter(p=>p.unitPrice>0);
      const freeRows=pkgRows.filter(p=>p.unitPrice===0);
      let html='';
      paidRows.forEach(p=>{
        html+=`<div style="display:flex;justify-content:space-between;padding:3px 0;font-size:12px;"><span>${p.lbl} Ambalaj (${p.count} adet)</span><span style="font-weight:600;">${fmt(p.unitPrice*p.count)}</span></div>`;
      });
      freeRows.forEach(p=>{
        html+=`<div style="display:flex;justify-content:space-between;padding:3px 0;font-size:12px;"><span>${p.lbl} Ambalaj (${p.count} adet)</span><span style="font-weight:600;color:#2E7D52;">Ücretsiz</span></div>`;
      });
      if(html){
        pe2.style.display='block';pe2.innerHTML=html;
        const aw=document.getElementById('kw-sum-ambalaj-wrap');if(aw)aw.style.display='block';
      }else{
        pe2.style.display='none';
        const aw=document.getElementById('kw-sum-ambalaj-wrap');if(aw)aw.style.display='none';
      }
    }
    const le=document.getElementById('kw-sum-logo-fee');
    if(le){if(lf>0){le.style.display='block';le.innerHTML=`<div style="display:flex;justify-content:space-between;padding:3px 0;font-size:12px;"><span>Logo Uygulaması (${pc} adet)</span><span style="font-weight:600;">+${fmt(lf)}</span></div>`;}else le.style.display='none';}
    const me=document.getElementById('kw-sum-mini-total');
    if(me){me.style.display='flex';me.style.justifyContent='space-between';me.style.alignItems='baseline';me.innerHTML=`<span style="font-size:9px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:var(--kw-taupe);">TAHMİNİ TUTAR</span><span style="font-size:18px;font-weight:700;color:var(--kw-darker);">${fmt(total)}</span>`;}
    const pa=document.getElementById('kw-acc-fiyat');
    if(pa)pa.style.display=s.step>=6&&s.quantityKg>=KW_MIN&&s.beans.length>0?'':'none';
  }

  async addToCart(buyNow) {
    if(this._busy) return;
    this._busy=true; this._cartLoading(true);
    const s=this._s;
    if(!s.beans?.length){kwToast('Çekirdek seçin.','warning');this._busy=false;this._cartLoading(false);return;}
    const sifirStok=s.beans.filter(b=>b.stockGr<=0&&b.stockGr<9999*1000);
    if(sifirStok.length){kwToast(sifirStok.map(b=>b.title).join(', ')+' stoğu tükendi.','error',5000);this._busy=false;this._cartLoading(false);return;}
    if(!s.roast){kwToast('Kavurma derecesi seçin.','warning');this._busy=false;this._cartLoading(false);return;}
    if(!s.quantityKg){kwToast('Miktar girin.','warning');this._busy=false;this._cartLoading(false);return;}
    const group='KKM-'+Date.now();
    const items=[];
    let beanErr=false;
    if(s.character==='single'){
      const b=s.beans[0],vid=parseInt(b.variantId);
      if(!vid||isNaN(vid)){kwToast(`${b.title} için variant ID eksik.`,'error',6000);beanErr=true;}
      else items.push({id:vid,quantity:s.quantityKg,properties:{'_group':group,'_label':'single','_tur':this._typeL(s.type),'_kavurma':this._roastL(s.roast),'_ogutme':this._grindL(s.grind)}});
    } else {
      let allocated=0; const beanItems=[];
      s.beans.forEach((b,idx)=>{
        const vid=parseInt(b.variantId);
        if(!vid||isNaN(vid)){kwToast(`${b.title} için variant ID eksik.`,'error',6000);beanErr=true;return;}
        let qty=idx===s.beans.length-1?s.quantityKg-allocated:Math.floor(s.quantityKg*b.ratio/100);
        if(qty<1)return; allocated+=qty;
        const bProps={'_group':group,'_label':'blend','_tur':this._typeL(s.type),'_kavurma':this._roastL(s.roast),'_ogutme':this._grindL(s.grind),'Karışım Oranı':'%'+b.ratio};
        let bPartNo=0;
        for(let bSent=0;bSent<qty;bSent+=50){bPartNo++;beanItems.push({id:vid,quantity:Math.min(50,qty-bSent),properties:{...bProps,'_p':String(bPartNo)}});}
      });
      beanItems.forEach(item=>items.push(item));
    }
    if(beanErr){this._busy=false;this._cartLoading(false);return;}
    (s.packages||[]).filter(p=>p.count>0).forEach(pkg=>{
      const ambId=s.pkgDesigns?.[pkg.sizeGr],amb=ambId?this.catalog.ambalajlar.find(a=>a.ambId===ambId):null;
      const vid=amb?.variantId?parseInt(amb.variantId):null;
      if(!vid||isNaN(vid)){kwToast(`${KW_PKG[pkg.sizeGr]?.label} ambalaj için variant ID eksik.`,'warning',6000);return;}
      items.push({id:vid,quantity:Math.round(pkg.count),properties:{'_group':group,'_label':'ambalaj'}});
    });
    const pkgCount=(s.packages||[]).reduce((a,p)=>a+p.count,0);
    if(s.designType==='custom'&&pkgCount>0){
      const logoVid=parseInt(window.KW_CONFIG?.logoVariantId||KW_LOGO_VID);
      if(logoVid&&!isNaN(logoVid)) items.push({id:logoVid,quantity:Math.round(pkgCount),properties:{'_group':group,'_label':'logo','Logo':s._logoUploadUrl||s.logoFile||''}});
    }
    if(!items.length){kwToast('Sepete eklenecek ürün bulunamadı.','error');this._busy=false;this._cartLoading(false);return;}
    try {
      s._logoUploadUrl=null;
      if(s.designType==='custom'&&s.logoUrl&&s.logoFile){
        try{
          const upRes=await fetch(KW_ADMIN+'/logo-upload.php',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({data:s.logoUrl,name:s.logoFile,order_ref:group})});
          if(upRes.ok){const upData=await upRes.json();s._logoUploadUrl=upData.url||null;}
        }catch(e){kwToast('Logo yüklenemedi, sipariş devam ediyor.','warning',4000);}
      }
      if(buyNow){
        await fetch('/cart/clear.js',{method:'POST'});
        const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});
        if(!r.ok) throw new Error(await r.text());
        this._skip=true;
        const f=document.createElement('form');f.method='POST';f.action='/checkout';document.body.appendChild(f);f.submit();
      } else {
        const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});
        if(!r.ok) throw new Error(await r.text());
        if(this.cfg.customerId) this._saveBlendSilent();
        this._reset(false); this.close();
        kwToast('Sipariş sepete eklendi!','success',4000);
        await new Promise(r=>setTimeout(r,200));
        await this._openCartDrawer();
      }
    } catch(err) {
      let msg=err.message||'';
      try{const p=JSON.parse(msg);msg=p.description||p.message||msg;}catch{}
      kwToast('Hata: '+msg,'error',6000);
    } finally { this._busy=false; this._cartLoading(false); }
  }

  _cartLoading(show) {
    let ov=document.getElementById('kw-cl');
    if(show){
      if(!ov){ov=document.createElement('div');ov.id='kw-cl';ov.style.cssText='position:fixed;inset:0;background:rgba(28,24,18,.45);z-index:99999;display:flex;align-items:center;justify-content:center;';ov.innerHTML='<div style="width:44px;height:44px;border:3px solid rgba(255,255,255,.2);border-top-color:#fff;border-radius:50%;animation:kwSpin .7s linear infinite;"></div>';if(!document.getElementById('kw-sp')){const st=document.createElement('style');st.id='kw-sp';st.textContent='@keyframes kwSpin{to{transform:rotate(360deg)}}';document.head.appendChild(st);}document.body.appendChild(ov);}
      ov.style.display='flex';
      ['kw-btn-cart','kw-btn-cart2','kw-btn-buynow','kw-btn-buynow2'].forEach(id=>{const b=document.getElementById(id);if(b)b.disabled=true;});
    } else {
      if(ov)ov.style.display='none';
      ['kw-btn-cart','kw-btn-cart2','kw-btn-buynow','kw-btn-buynow2'].forEach(id=>{const b=document.getElementById(id);if(b)b.disabled=false;});
    }
  }

  async _openCartDrawer() {
    let cart; try{cart=await fetch('/cart.js',{cache:'no-store'}).then(r=>r.json());}catch(e){}
    if(cart){document.querySelectorAll('[data-cart-count],[data-cart-item-count]').forEach(el=>{el.textContent=String(cart.item_count||0);});}
    const drawerComp=document.querySelector('cart-drawer-component');
    if(drawerComp){
      const hadAutoOpen=drawerComp.hasAttribute('auto-open');
      if(!hadAutoOpen)drawerComp.setAttribute('auto-open','');
      try{
        const sectionsRes=await fetch('/cart?sections=cart-drawer',{cache:'no-store'});
        const sectionsData=await sectionsRes.json();
        document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:cart,data:{sections:sectionsData,source:'kkm-wizard',item_count:cart?.item_count||1}}}));
      }catch(e){}
      await new Promise(r=>setTimeout(r,300));
      if(typeof drawerComp.open==='function') drawerComp.open();
      if(!hadAutoOpen)drawerComp.removeAttribute('auto-open');
      return;
    }
    const btn=document.querySelector('#cart-icon-bubble,[data-cart-toggle],button[aria-label="Sepet"],button[aria-label="Cart"],.header__icon--cart');
    if(btn){btn.click();return;}
    window.location.href='/cart';
  }

  _saveBlendSilent(){
    const s=this._s; if(!s.beans?.length||!this.cfg.customerId)return;
    const blend={id:Date.now(),name:this._typeL(s.type)+' · '+s.beans.map(x=>x.title).join(' + '),type:s.type,character:s.character,roast:s.roast,beans:s.beans.map(x=>({id:x.id,title:x.title,ratio:x.ratio,color:x.color})),createdAt:new Date().toISOString()};
    const key='kw_blends_'+this.cfg.customerId;
    const arr=JSON.parse(localStorage.getItem(key)||'[]');arr.push(blend);localStorage.setItem(key,JSON.stringify(arr));
  }
  async saveBlend(){
    if(!this.cfg.customerId){kwToast('Giriş yapmanız gerekiyor.','warning');return;}
    this._saveBlendSilent();this._loadSaved();kwToast('Harman kaydedildi!','success');
  }
  _loadSaved(){
    const key=this.cfg.customerId?'kw_blends_'+this.cfg.customerId:'kw_blends_guest';
    const saved=JSON.parse(localStorage.getItem(key)||'[]');
    const el=document.getElementById('kw-saved-list');if(!el)return;
    if(!saved.length){el.innerHTML='<p class="kw-saved-empty">Henüz kayıtlı harman yok.</p>';return;}
    el.innerHTML=saved.slice().reverse().slice(0,10).map(b=>`<div class="kw-saved-item"><div><strong>${b.name}</strong><small>${this._roastL(b.roast)} · ${new Date(b.createdAt).toLocaleDateString('tr-TR')}</small></div><div style="display:flex;gap:6px;"><button class="kw-btn kw-btn--ghost kw-btn--sm kw-saved-load" data-id="${b.id}">Yükle</button><button class="kw-btn kw-btn--ghost kw-btn--sm kw-saved-del" data-id="${b.id}" style="color:#c0392b;">Sil</button></div></div>`).join('');
  }
  _loadBlend(id){
    const key=this.cfg.customerId?'kw_blends_'+this.cfg.customerId:'kw_blends_guest';
    const list=JSON.parse(localStorage.getItem(key)||'[]');
    const b=list.find(x=>String(x.id)===String(id));if(!b)return;
    this._s.type=b.type;this._s.character=b.character;this._s.roast=b.roast;
    this._s.beans=b.beans.map(x=>({...this.catalog.cekirdekler.find(c=>c.id===x.id),ratio:x.ratio})).filter(x=>x?.id);
    this._goStep(4);kwToast(`"${b.name}" yüklendi.`,'success');
  }
  _loadBlendById(id){
    const key=this.cfg.customerId?'kw_blends_'+this.cfg.customerId:'kw_blends_guest';
    const list=JSON.parse(localStorage.getItem(key)||'[]');
    const b=list.find(x=>String(x.id)===String(id));if(!b){this._goStep(1);return;}
    this._s.type=b.type;this._s.character=b.character;this._s.roast=b.roast;
    this._s.beans=b.beans.map(x=>({...this.catalog.cekirdekler.find(c=>c.id===x.id),ratio:x.ratio})).filter(x=>x?.id);
    this._goStep(4);
  }
  async _deleteBlend(id){
    if(!await kwConfirm('Bu harman silinecek. Emin misiniz?'))return;
    const key=this.cfg.customerId?'kw_blends_'+this.cfg.customerId:'kw_blends_guest';
    try{const list=JSON.parse(localStorage.getItem(key)||'[]');localStorage.setItem(key,JSON.stringify(list.filter(x=>String(x.id)!==String(id))));}catch(e){}
    this._loadSaved();kwToast('Harman silindi.','info');
  }
  async _confirmReset(){ if(!await kwConfirm('Tüm seçimler silinecek. Emin misiniz?'))return; this._reset(); }

  _autoSelectAndAdvance(n) {
    const vis=el=>{const s=window.getComputedStyle(el);return s.display!=='none'&&s.visibility!=='hidden'&&el.closest('.kw-step')?.style.display!=='none';};
    let changed=false;
    if(n===1&&!this._s.type){const cc=[...document.querySelectorAll('[data-group="step1-type"]')].filter(vis);if(cc.length===1){cc[0].classList.add('selected');this._s.type=cc[0].dataset.value;this._s.beans=[];changed=true;}}
    if(n===2&&!this._s.character){const cc=[...document.querySelectorAll('[data-group="step2-character"]')].filter(vis);if(cc.length===1){cc[0].classList.add('selected');this._s.character=cc[0].dataset.value;this._s.beans=[];changed=true;}}
    if(n===3&&!this._s.beans.length){const cc=[...document.querySelectorAll('[data-group="bean"]')].filter(e=>vis(e)&&e.style.pointerEvents!=='none');if(cc.length===1){this._toggleBean(cc[0].dataset.value);changed=true;}}
    if(n===4){
      const rc=[...document.querySelectorAll('[data-group="step4-roast"]')].filter(vis);
      if(rc.length===1&&!this._s.roast){rc[0].classList.add('selected');this._s.roast=rc[0].dataset.value;this._renderRoast();changed=true;}
      const gs=document.getElementById('kw-grind-'+(this._s.type||'filtre'));
      if(gs){const gc=[...gs.querySelectorAll('[data-group="step4-grind"]')].filter(vis);if(gc.length===1&&!this._s.grind){gc[0].classList.add('selected');this._s.grind=gc[0].dataset.value;changed=true;}}
    }
    if(changed){this._summary();this._navBtns();this._save();if(this._valid())setTimeout(()=>this.next(),220);}
  }

  _navBtns(){
    const nb=document.getElementById('kw-btn-next'),cb=document.getElementById('kw-cart-btns'),last=this._s.step===this.cfg.totalSteps;
    if(nb){nb.style.display=last?'none':'inline-flex';nb.disabled=false;nb.onclick=(e)=>{if(!this._valid()){e.preventDefault();nb.classList.add('kw-btn--error-flash');setTimeout(()=>nb.classList.remove('kw-btn--error-flash'),600);this._showStepError();return;}this.next();};}
    if(cb)cb.style.display=last?'flex':'none';
    if(last){const bc=document.getElementById('kw-btn-cart'),bn=document.getElementById('kw-btn-buynow');if(bc)bc.disabled=!this._s.designType;if(bn)bn.disabled=!this._s.designType;}
    const allDone=this._s.type&&this._s.character&&this._beansOk()&&this._s.roast&&this._s.quantityKg>=KW_MIN&&this._pkgsOk()&&!!this._s.designType;
    const b2=document.getElementById('kw-btn-buynow2'),b3=document.getElementById('kw-btn-cart2');if(b2)b2.disabled=!allDone;if(b3)b3.disabled=!allDone;
  }
  _showStepError(msg){
    const s=this._s;
    if(!msg)switch(s.step){
      case 1:msg='Kahve türü seçin';break;case 2:msg='Çekirdek yapısını seçin';break;
      case 3:if(!s.beans.length)msg='En az bir çekirdek seçin';else if(s.character==='blend'&&s.beans.reduce((a,b)=>a+b.ratio,0)!==100)msg='Harman oranları %100 olmalı';else if(s.beans.some(b=>b.stockGr<=0))msg='Stoku tükenen çekirdekler seçili.';break;
      case 4:msg=!s.roast?'Kavurma profili seçin':!s.grind?'Öğütme derecesi seçin':'';break;
      case 5:msg=`Minimum ${KW_MIN} kg seçin`;break;
      case 6:{
        const totalGr6=s.quantityKg*1000;
        const usedGr6=(s.packages||[]).reduce((a,p)=>a+p.sizeGr*p.count,0);
        const remGr6=totalGr6-usedGr6;
        if(remGr6>0){const remLbl=remGr6>=1000?`${remGr6/1000} kg`:`${remGr6} gr`;msg=`${remLbl} daha eklemeniz gerekiyor`;}
        else if(remGr6<0){const exLbl=(-remGr6)>=1000?`${-remGr6/1000} kg`:`${-remGr6} gr`;msg=`${exLbl} fazla seçtiniz`;}
        setTimeout(()=>{const bar=document.getElementById('kw-pkg-bar-wrap');if(bar)bar.scrollIntoView({behavior:'smooth',block:'center'});},100);
        break;
      }
      case 7:{
        const active7=(s.packages||[]).filter(p=>p.count>0);
        const missing7=active7.filter(p=>!s.pkgDesigns?.[p.sizeGr]);
        if(missing7.length>0){
          const lbl=missing7.map(p=>KW_PKG[p.sizeGr]?.label||p.sizeGr+'gr').join(', ');
          msg=`${lbl} için ambalaj seçilmedi`;
          setTimeout(()=>{
            const sec=document.querySelector(`.kw-ambalaj-section [data-size="${missing7[0].sizeGr}"]`);
            if(sec)sec.closest('.kw-ambalaj-section')?.scrollIntoView({behavior:'smooth',block:'center'});
          },100);
        } else if(!s.designType){msg='Logo uygulaması seçin';}
        else if(s.designType==='custom'&&!s.logoUrl){msg='Logo dosyası yükleyin';}
        break;
      }default:msg='Seçiminizi tamamlayın';
    }
    if(!msg)return;
    const err=document.getElementById('kw-step-error');if(!err)return;
    err.textContent=msg;err.style.display='flex';err.classList.add('kw-step-error--visible');
    err.scrollIntoView({behavior:'smooth',block:'nearest'});
    clearTimeout(this._et);this._et=setTimeout(()=>{err.classList.remove('kw-step-error--visible');setTimeout(()=>err.style.display='none',300);},4000);
  }

  _txt(id,v){const e=document.getElementById(id);if(e)e.textContent=v||'—';}
  _typeL(v){return{filtre:'Filtre Kahve',turk:'Türk Kahvesi',espresso:'Espresso'}[v]||'—';}
  _charL(v){return{single:'Single Origin',blend:'Blend (Harman)'}[v]||'—';}
  _roastL(v){return{light:'Light',medium:'Medium',dark:'Medium Dark'}[v]||'—';}
  _grindL(v){return{cekirdek:'Çekirdek','filtre-kaba':'Kaba Öğütülmüş','filtre-orta':'Orta Öğütülmüş','filtre-ince':'İnce Öğütülmüş',turk:'Türk Kahvesi İnce'}[v]||'—';}
}

document.addEventListener('DOMContentLoaded', () => {
  window.kahveWizard = new KahveWizard({
    totalSteps: window.KW_CONFIG?.totalSteps || 8,
    currency:   window.KW_CONFIG?.currency   || 'TRY',
    customerId: window.KW_CONFIG?.customerId || '',
  });
  const ov=document.getElementById('kw-overlay'),cl=document.getElementById('kw-close');
  if(ov) ov.style.display='block';
  if(cl) cl.style.display='none';
  const summaryToggle=document.getElementById('kw-summary-toggle');
  const summaryEl=document.getElementById('kw-summary');
  if(summaryToggle&&summaryEl){summaryToggle.addEventListener('click',()=>{summaryEl.classList.toggle('kw-summary--open');});}
});